import React, { useState, useRef , useEffect } from 'react';
import useGetState from '../../hooks/useGetState';
import  { useContext } from 'react';
// import img from '../../components/img';
// import img from '../../components/img';
import { CartContext } from '../../context/CartContext';
import { ServiceContext } from '../../context/ServiceContext';
import { useLocationContext  } from '../../context/LocationContext.jsx';
import axios from 'axios'
import { notification } from 'antd';
import { useParams, useSearchParams, useLocation  } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { max } from 'moment';
import './promotionPopup.css';
import '../restaurant/restaurant.css';
import { useSharedCart } from '../../hooks/useSharedCart';
import PartnerAddPopup from '../../components/partnerAddPopup/PartnerAddPopup';

// import PreloadImage from 'react-image-preloader';


function MenuList() {
    const warningPlacement = { placement: 'top', top: 132 };

    useEffect(() => {
        notification.config({
            placement: 'top',
            top: 132,
            zIndex: 10030,
            getContainer: () => document.body,
        });
    }, []);

    // Add these state variables at the top with other useState hooks
    const [walkingPageSetup, setWalkingPageSetup] = useState(0); // Default to 0 (no landing page)
    const [loadingPageColor, setLoadingPageColor] = useState('#ffffff'); // Default color
    const [loadingPagePercentage, setLoadingPagePercentage] = useState(1); // Default opacity (1 means fully opaque)
    const [showLandingPage, setShowLandingPage] = useState(false); // Controls visibility

    const [MaxItemInCart, setMaxItemInCart] = useState(0);

    // Promotion state
    const [promotionEnabled, setPromotionEnabled] = useState(false);
    const [promotionTitle, setPromotionTitle] = useState('');
    const [promotionDescription, setPromotionDescription] = useState('');
    const [promotionType, setPromotionType] = useState('');
    const [promotionValue, setPromotionValue] = useState(0);
    const [promotionMinAmount, setPromotionMinAmount] = useState(0);
    const [showPromotionPopup, setShowPromotionPopup] = useState(false);
    const [countdown, setCountdown] = useState(5);
    const [menuGroupSelectionEnabled, setMenuGroupSelectionEnabled] = useState(false);
    const [menuGroupOptions, setMenuGroupOptions] = useState([]);
    const [showMenuGroupPopup, setShowMenuGroupPopup] = useState(false);
    const [selectedMenuGroupCode, setSelectedMenuGroupCode] = useState('');
    const [pendingMenuGroupCode, setPendingMenuGroupCode] = useState('');
    const [menuGroupSelectionSkipped, setMenuGroupSelectionSkipped] = useState(false);

    // Customer Menu Show Price state
    const [showPriceInCustomerMenu, setShowPriceInCustomerMenu] = useState(true);
    const [enableSharedCart, setEnableSharedCart] = useState(true);
    const [requireDineInGuestCount, setRequireDineInGuestCount] = useState(false);
    const [showGuestCountPopup, setShowGuestCountPopup] = useState(false);
    const [selectedGuestCount, setSelectedGuestCount] = useState(2);
    const [customGuestCount, setCustomGuestCount] = useState('');
    const [customGuestCountMode, setCustomGuestCountMode] = useState(false);
    const [serverHasDineInGuestCount, setServerHasDineInGuestCount] = useState(false);
    const [hasExistingTableOrder, setHasExistingTableOrder] = useState(false);
    const [showPromotionAfterGuestCount, setShowPromotionAfterGuestCount] = useState(false);

    const [serviceAvailable, setServiceAvailable] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const locationState = location.state || {};
    const { orderingMore } = locationState;

    const [hasUnpaidOrder, setHasUnpaidOrder, gethasUnpaidOrder] = useGetState(false);
    const { isLocationValid, setLocationValid } = useLocationContext();
    const [showNoteBox, setShowNoteBox] = useState(false);
    const [note, setNote] = useState('');

    const [iconloading, setIconloading] = useState(false);

    // const [browserLanguage, setBrowserLanguage] = useState('');
    // //可能的输出："en", "zh", "ko", "ja", 越"vi", 泰"th" 等
    // useEffect(() => {
    //     const defaultLanguage = navigator.language || navigator.userLanguage;
    //     setBrowserLanguage(defaultLanguage.slice(0, 2));

    const cartIconRef = useRef(null);
    const optionsProductRef = useRef(null);
    // }, []);

    const [storeLocation, setStoreLocation] = useState(null);
    const [fetchDataTag, setFetchDataTag] = useState(false);
    const [storeConfigTag, setStoreConfigTag] = useState(false);
    const [menuImageVersion, setMenuImageVersion] = useState(Date.now());

    const [firstLanguage, setFirstLanguage] = useState(null);
    const [secondLanguage, setSecondLanguage] = useState(null);
    const [currentLanguage, setCurrentLanguage] = useState(null);
    const [UILanguage, setUILanguage] = useState('en');

    const [monBusinessHours, setMonBusinessHours] = useState(null);
    const [tueBusinessHours, setTueBusinessHours] = useState(null);
    const [wedBusinessHours, setWedBusinessHours] = useState(null);
    const [thuBusinessHours, setThuBusinessHours] = useState(null); 
    const [friBusinessHours, setFriBusinessHours] = useState(null);
    const [satBusinessHours, setSatBusinessHours] = useState(null);
    const [sunBusinessHours, setSunBusinessHours] = useState(null);

    const [payFirst, setPayFirst] = useState(null);
    const [useLocation1, setUseLocation1] = useState(null);
    const [noAuth, setNoAuth] = useState(null);
    const [useSpellInstruction, setUseSpellInstruction] = useState(null);
    const [storeLocationRange, setStoreLocationRange] = useState(null);

    const [multipleLanguage, setMultipleLanguage] = useState(false);
 

    const { cart,swapDescriptionsInCart , addOrderToCart, removeOrderFromCart,editaddOrderToCart, clearCart, totalQuantity, totalAmount, getMainItemQuantity} = useContext(CartContext);
    const { tableNumber, setTableNumber,storeId, setStoreId, serviceMode, setServiceMode, language, setLanguage,setUiLanguage,storeName,setStoreName,dineInGuestCount,setDineInGuestCount} = useContext(ServiceContext);

    const { restaurantUrl } = useParams();

    const {tableNo} = useParams();

    const isDineInTable = tableNo && tableNo.toLowerCase() !== 'take_away' && tableNo !== 'Take-away';

    const applyDineInGuestState = (storeConfig, tableOrder, serverGuestCountValue) => {
        const shouldRequireGuestCount = storeConfig.RequireDineInGuestCount !== 0;
        const tableHasExistingOrder = Boolean(tableOrder && Number(tableOrder.Paid) === 0);
        const serverGuestCount = Number(serverGuestCountValue);
        const hasServerGuestCount = Number.isInteger(serverGuestCount) && serverGuestCount > 0;

        setRequireDineInGuestCount(shouldRequireGuestCount);
        setHasExistingTableOrder(tableHasExistingOrder);
        setServerHasDineInGuestCount(hasServerGuestCount);

        if (hasServerGuestCount) {
            setSelectedGuestCount(serverGuestCount);
            setCustomGuestCount(serverGuestCount > 5 ? String(serverGuestCount) : '');
            setCustomGuestCountMode(serverGuestCount > 5);
            setDineInGuestCount(serverGuestCount);
            return {
                shouldRequireGuestCount,
                tableHasExistingOrder,
                hasServerGuestCount,
                guestCount: serverGuestCount,
            };
        }

        if (shouldRequireGuestCount && isDineInTable) {
            setDineInGuestCount(null);
        } else if (!shouldRequireGuestCount || !isDineInTable || tableHasExistingOrder) {
            setDineInGuestCount(null);
        }

        return {
            shouldRequireGuestCount,
            tableHasExistingOrder,
            hasServerGuestCount,
            guestCount: null,
        };
    };

    const refreshDineInGuestState = async () => {
        if (!isDineInTable) {
            return {
                shouldRequireGuestCount: false,
                tableHasExistingOrder: false,
                hasServerGuestCount: false,
                guestCount: null,
            };
        }

        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/fetchStoreConfig/${restaurantUrl}`, { tableNumber: tableNo });
        return applyDineInGuestState(response.data.storeConfig, response.data.tableOrder, response.data.dineInGuestCount);
    };

    // 共享购物车（多人点餐）：仅堂食场景且门店配置启用时启用
    const { partnerFirstAdd, clearPartnerFirstAdd } = useSharedCart(restaurantUrl, tableNo, enableSharedCart);

    const menuItemImageUrl = (itemCode) => (
        `${process.env.REACT_APP_SERVER_URL}/images/${storeId}/menuItems/${itemCode}?v=${menuImageVersion}`
    );

    const menuGroupSelectionKey = `menuGroupSelection:${restaurantUrl}:${tableNo}`;
    const menuGroupImageUrl = (code, sid = storeId) => (
        `${process.env.REACT_APP_SERVER_URL}/images/${sid}/menuGroups/${code}?v=${menuImageVersion}`
    );


   
    const [searchParams] = useSearchParams();
    const categoryquery = searchParams.get('category');
    const mode = searchParams.get('mode') || '';  
    const [modeType, setModeType] = useState(mode);
   

    const [showLimitMessage, setShowLimitMessage] = useState(false);
    const [showMaxLimitMessage, setShowMaxLimitMessage] = useState(false);
    const [mustBeSelectedMessage, setMustBeSelectedMessage] = useState(null);
    const [menuItemCooldowns, setMenuItemCooldowns] = useState({});
    const [orderedItemQuantities, setOrderedItemQuantities] = useState({});
    const [orderedCategoryQuantities, setOrderedCategoryQuantities] = useState({});
    

    
    
    const [storeAddress, setStoreAddress] = useState(null);
    const [storePhone, setStorePhone] = useState(null);
    const [DisableOrderTracking, setDisableOrderTracking] = useState(null);
    const [storeImg, setStoreImg] = useState(null);
    const [storeTimetable, setStoreTimetable, getStoreTimetable] = useGetState(null);
    const [toggleOptionsPopup, setToggleOptionsPopup] = useState(false);
    const toggleOptions = () => {
        setToggleOptionsPopup(!toggleOptionsPopup);
    };

    // 使用对象来存储每个菜单项的展开/收起状态
    const [optionsPopupState, setOptionsPopupState] = useState({});
    
    // 修改 toggleOptions 函数
    const toggleOptionsPopupState = (index) => {
        setOptionsPopupState(prevState => ({
            ...prevState,
            [index]: !prevState[index]
        }));
    };
    const [side_popup, setSide_popup] = useState(false);
    const toggleSidePopup = () => {
        setSide_popup(!side_popup);
    };
    const [categoryList, setCategoryList] = useState([]);
    const [mainCategories, setMainCategories] = useState({}); // 第一个数据结构
   

    const [selectedCategory, setSelectedCategory] = useState(null);

    const [languagepopup, setLanguagepopup] = useState(false);
    const toggleLanguagepopup = () => setLanguagepopup(!languagepopup);
    

    const [fullCategorypopup, setFullCategorypopup] = useState(false);
    const toggleFullCategorypopup = () => setFullCategorypopup(!fullCategorypopup);

    const [submenuData, setSubmenuData] = useState([]); // 第三个数据结构
    const [selectedSubmenu, setSelectedSubmenu] = useState(null);

    const [selectedSubmenuItems, setSelectedSubmenuItems] = useState([]);

    const [selectedTotalPrice, setSelectedTotalPrice, getSelectedTotalPrice] = useGetState(null);
    const [selectedmainItemPrice, setSelectedmainItemPrice] = useState(null);
    const [selectedmainItemQty, setSelectedmainItemQty] = useState(1);
    const [selectedmainItemPosition, setSelectedmainItemPosition] = useState(0);
    const [selectedMutipleButtonPosition, setSelectedMultipleButtonPosition] = useState(0);

    const [selectedSubMenuCodes, setSelectedSubMenuCodes] = useState({});//单选

    const [toggleCartpopup, setToggleCartpopup] = useState(false);
    const toggleCartPopup = () => {
       
        setToggleCartpopup(!toggleCartpopup);
    };
    // useEffect(() => {
    //     //clear All session
    //     sessionStorage.clear();
    // }, []);

    const[restoreOrder, setRestoreOrder] = useState(null);

    const handleItemClick = (event, order) => {

        // 检查点击的元素是否是按钮
        if (!event.target.matches('button') && !event.target.matches('button *') && order.length > 2) {
            // 不是按钮，处理显示逻辑
            toggleCartPopup();         
            setRestoreOrder(order);
            handleSelectOptionsClick(order[1].mainItemCode, order[1].category, order); // 显示弹出窗口
        }
        
    };


    useEffect(() => {
        const fetchStoreConfig = async () => {
            localStorage.removeItem('hasVisitedPayment');

            try {
                
                const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/fetchStoreConfig/${restaurantUrl}`, { tableNumber: tableNo });

                if (!response.data.storeConfig.QRFunctionEnable){
                    navigate('/disableQR')
                }
                setFirstLanguage(response.data.storeConfig.FirstLanguage);
                setSecondLanguage(response.data.storeConfig.SecondLanguage);
                setStoreAddress(response.data.storeInformation.StoreAddress);
                setStorePhone(response.data.storeInformation.StorePhone);
                setMaxItemInCart(response.data.storeConfig.MaxItemInCart);

                const defaultLanguage = navigator.language || navigator.userLanguage;
                // console.log(defaultLanguage.slice(0, 2));
                
                if (response.data.storeConfig.MultiLanguage ===0) {
                    setLanguage(0);
                    

                    
                }
                else{
                    if ((defaultLanguage.slice(0, 2) === response.data.storeConfig.FirstLanguage) || (defaultLanguage.slice(0, 2) =="zh" && response.data.storeConfig.FirstLanguage =="zf")) {
                        setLanguage(0);
                        setUILanguage(response.data.storeConfig.FirstLanguage);
                        setUiLanguage(response.data.storeConfig.FirstLanguage);
                    }   
                    else if (defaultLanguage.slice(0, 2) === response.data.storeConfig.SecondLanguage || (defaultLanguage.slice(0, 2) =="zh" && response.data.storeConfig.SecondLanguage =="zf")) {
                        setLanguage(1);
                        setUILanguage(response.data.storeConfig.SecondLanguage);
                        setUiLanguage(response.data.storeConfig.SecondLanguage);
                    }
                }
                setMultipleLanguage(response.data.storeConfig.MultiLanguage);


                //response.data.MondayStart, MondayEnd, TuesdayStart, TuesdayEnd, WednesdayStart, WednesdayEnd, ThursdayStart, ThursdayEnd, FridayStart, FridayEnd, SaturdayStart, SaturdayEnd, SundayStart, SundayEnd
                const {
                    MondayStart, MondayEnd, MondayBreakStart, MondayBreakEnd,
                    TuesdayStart, TuesdayEnd, TuesdayBreakStart, TuesdayBreakEnd,
                    WednesdayStart, WednesdayEnd, WednesdayBreakStart, WednesdayBreakEnd,
                    ThursdayStart, ThursdayEnd, ThursdayBreakStart, ThursdayBreakEnd,
                    FridayStart, FridayEnd, FridayBreakStart, FridayBreakEnd,
                    SaturdayStart, SaturdayEnd, SaturdayBreakStart, SaturdayBreakEnd,
                    SundayStart, SundayEnd, SundayBreakStart, SundayBreakEnd,
                } = response.data.storeConfig;
                
                  const timeZoneMap = {
                    'Brisbane': 'Australia/Brisbane',
                    'Sydney': 'Australia/Sydney',
                    'Melbourne': 'Australia/Melbourne'
                };
                
                // 获取对应的时区标识符
                const timeZone = timeZoneMap[response.data.storeInformation.Location];
                
                
                if (timeZone) {
                    const currentDate = new Date().toLocaleString("en-US", { timeZone: timeZone });
                    const currentDay = new Date(currentDate).getDay();
                    const currentTime = new Date(currentDate).toLocaleTimeString('en-US', { hour12: false });
                    
                    let start, end, breakStart, breakEnd;
                    switch (currentDay) {
                        case 0: // Sunday
                            [start, end, breakStart, breakEnd] = [SundayStart, SundayEnd, SundayBreakStart, SundayBreakEnd];
                            break;
                        case 1: // Monday
                            [start, end, breakStart, breakEnd] = [MondayStart, MondayEnd, MondayBreakStart, MondayBreakEnd];
                            break;
                        case 2: // Tuesday
                            [start, end, breakStart, breakEnd] = [TuesdayStart, TuesdayEnd, TuesdayBreakStart, TuesdayBreakEnd];
                            break;
                        case 3: // Wednesday
                            [start, end, breakStart, breakEnd] = [WednesdayStart, WednesdayEnd, WednesdayBreakStart, WednesdayBreakEnd];
                            break;
                        case 4: // Thursday
                            [start, end, breakStart, breakEnd] = [ThursdayStart, ThursdayEnd, ThursdayBreakStart, ThursdayBreakEnd];
                            break;
                        case 5: // Friday
                            [start, end, breakStart, breakEnd] = [FridayStart, FridayEnd, FridayBreakStart, FridayBreakEnd];
                            break;
                        case 6: // Saturday
                            [start, end, breakStart, breakEnd] = [SaturdayStart, SaturdayEnd, SaturdayBreakStart, SaturdayBreakEnd];
                            break;
                        default:
                            console.error(`Invalid day: ${currentDay}`);
                            navigate('/unavailable');
                            return;
                    }
                
                    // 检查是否跨午夜营业 (比如 10:00 到次日 02:00)
                    const isOvernightHours = start > end;
                    let isWithinOperatingHours = false;
                    
                    if (isOvernightHours) {
                        // 跨午夜营业：当前时间 >= 开始时间 OR 当前时间 <= 结束时间
                        isWithinOperatingHours = (currentTime >= start || currentTime <= end);
                    } else {
                        // 正常营业：当前时间在开始和结束时间之间
                        isWithinOperatingHours = (currentTime >= start && currentTime <= end);
                    }
                    
                    // 检查是否在休息时间内
                    let isInBreakTime = false;
                    if (breakStart !== null && breakEnd !== null) {
                        const isOvernightBreak = breakStart > breakEnd;
                        if (isOvernightBreak) {
                            // 跨午夜休息时间
                            isInBreakTime = (currentTime >= breakStart || currentTime <= breakEnd);
                        } else {
                            // 正常休息时间
                            isInBreakTime = (currentTime >= breakStart && currentTime <= breakEnd);
                        }
                    }
                    
                    if (isWithinOperatingHours && !isInBreakTime) {
                        console.log("Store is open.");
                        setServiceAvailable(true);

                    } else if (isInBreakTime && response.data.storeConfig.WalkingPageSetup !== 1) {
                        console.log("Store is on break.");
                        if (modeType !== 'menuSetupMode') {
                            navigate('/unavailable');
                        }
                    } else {
                        if (modeType !== 'menuSetupMode'  && response.data.storeConfig.WalkingPageSetup !== 1) {
                            navigate('/unavailable');
                        }
                        console.log("Store is closed.");
                       
                    }
                    
                }

                setStoreTimetable({
                    Monday: { start: MondayStart, end: MondayEnd, breakStart: MondayBreakStart, breakEnd: MondayBreakEnd },
                    Tuesday: { start: TuesdayStart, end: TuesdayEnd, breakStart: TuesdayBreakStart, breakEnd: TuesdayBreakEnd },
                    Wednesday: { start: WednesdayStart, end: WednesdayEnd, breakStart: WednesdayBreakStart, breakEnd: WednesdayBreakEnd },
                    Thursday: { start: ThursdayStart, end: ThursdayEnd, breakStart: ThursdayBreakStart, breakEnd: ThursdayBreakEnd },
                    Friday: { start: FridayStart, end: FridayEnd, breakStart: FridayBreakStart, breakEnd: FridayBreakEnd },
                    Saturday: { start: SaturdayStart, end: SaturdayEnd, breakStart: SaturdayBreakStart, breakEnd: SaturdayBreakEnd },
                    Sunday: { start: SundayStart, end: SundayEnd, breakStart: SundayBreakStart, breakEnd: SundayBreakEnd }
                });
                

                const tableHasExistingOrder = Boolean(response.data.tableOrder && Number(response.data.tableOrder.Paid) === 0);
                setHasExistingTableOrder(tableHasExistingOrder);
                if (response.data.tableOrder){
                    if (response.data.tableOrder.Paid === 1 && response.data.tableOrder.OrderEnrichNo === null && tableNo.toLowerCase() !== 'take_away' && tableNo !== 'Take-away') {
                        navigate(`/qr_order/${restaurantUrl}/order-success/${response.data.tableOrder.OrderId}`);
                    }
                }
                setUseLocation1(response.data.storeConfig.UseLocation);
                setNoAuth(response.data.storeConfig.NoAuth);
                setPayFirst(response.data.storeConfig.PayFirst);
                
                setUseSpellInstruction(response.data.storeConfig.UseSpellInstruction);
                setStoreLocationRange(response.data.storeInformation.StoreLocationRange);



                setWalkingPageSetup(response.data.storeConfig.WalkingPageSetup);
                setLoadingPageColor(response.data.storeConfig.LoadingPageColor);
                setLoadingPagePercentage(response.data.storeConfig.LoadingPagePercentage);

                // Set promotion data
                setPromotionEnabled(response.data.storeConfig.PromotionEnable === 1);
                setPromotionTitle(response.data.storeConfig.PromotionTitle || '');
                setPromotionDescription(response.data.storeConfig.PromotionDescription || '');
                setPromotionType(response.data.storeConfig.PromotionType || '');
                setPromotionValue(response.data.storeConfig.PromotionValue || 0);
                setPromotionMinAmount(response.data.storeConfig.PromotionMinAmount || 0);

                // Set Customer Menu Show Price
                setShowPriceInCustomerMenu(response.data.storeConfig.ShowPriceInCustomerMenu !== 0);
                setEnableSharedCart(response.data.storeConfig.EnableSharedCart !== 0);
                let fetchedMenuGroups = [];
                const shouldUseMenuGroupSelection = response.data.storeConfig.EnableMenuGroupSelection === 1;
                setMenuGroupSelectionEnabled(shouldUseMenuGroupSelection);
                if (shouldUseMenuGroupSelection) {
                    try {
                        const menuGroupResponse = await axios.get(`${process.env.REACT_APP_SERVER_URL}/menu-group-selection/${restaurantUrl}`);
                        fetchedMenuGroups = menuGroupResponse.data.enabled ? (menuGroupResponse.data.menuGroups || []) : [];
                        setMenuGroupOptions(fetchedMenuGroups);
                    } catch (error) {
                        console.error('Error fetching menu groups:', error);
                        setMenuGroupOptions([]);
                    }
                } else {
                    setMenuGroupOptions([]);
                    setSelectedMenuGroupCode('');
                    setPendingMenuGroupCode('');
                    setMenuGroupSelectionSkipped(false);
                }
                const guestState = applyDineInGuestState(response.data.storeConfig, response.data.tableOrder, response.data.dineInGuestCount);
                const menuGroupLocked = cart.length > 0 || guestState.tableHasExistingOrder;
                const rememberedSelection = sessionStorage.getItem(menuGroupSelectionKey);
                const cartMenuGroup = cart.length > 0 ? cart[0]?.[1]?.menuGroup : '';
                const lockedMenuGroup = rememberedSelection && rememberedSelection !== '__skip__' ? rememberedSelection : cartMenuGroup;
                const hasLockedMenuGroup = lockedMenuGroup && fetchedMenuGroups.some(group => group.Code === lockedMenuGroup);

                if (menuGroupLocked) {
                    if (hasLockedMenuGroup) {
                        setSelectedMenuGroupCode(lockedMenuGroup);
                        setPendingMenuGroupCode(lockedMenuGroup);
                        sessionStorage.setItem(menuGroupSelectionKey, lockedMenuGroup);
                    }
                    setMenuGroupSelectionSkipped(false);
                } else {
                    sessionStorage.removeItem(menuGroupSelectionKey);
                    setSelectedMenuGroupCode('');
                    setPendingMenuGroupCode('');
                    setMenuGroupSelectionSkipped(false);
                }

                if (response.data.storeConfig.WalkingPageSetup === 1) {
                    setShowLandingPage(true);
                } else if (guestState.shouldRequireGuestCount && isDineInTable && !guestState.hasServerGuestCount && !guestState.tableHasExistingOrder) {
                    setShowPromotionAfterGuestCount(response.data.storeConfig.PromotionEnable === 1 || (shouldUseMenuGroupSelection && fetchedMenuGroups.length > 0));
                    setShowGuestCountPopup(true);
                } else if (response.data.storeConfig.PromotionEnable === 1) {
                    if (shouldUseMenuGroupSelection && fetchedMenuGroups.length > 0 && !menuGroupLocked) {
                        setShowMenuGroupPopup(true);
                    } else {
                        setTimeout(() => {
                            setShowPromotionPopup(true);
                            setCountdown(10);
                        }, 500);
                    }
                } else if (shouldUseMenuGroupSelection && fetchedMenuGroups.length > 0 && !menuGroupLocked) {
                    setShowMenuGroupPopup(true);
                }
                setStoreConfigTag(true);


       
            }
            catch (error) {
                console.error('Error fetching store config:', error);
            }
        };
  
            // fetch table order if not paid
        const fetchTableOrder = async () => {
            
            
            try {
                const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/fetchTableOrder/${restaurantUrl}`, { tableNo });
              

             
                if (response.data.order && response.data.orderStatus === 'error') {
                    setHasExistingTableOrder(true);
                    navigate(`/qr_order/${restaurantUrl}/order-success/${response.data.order}`);
                }
               
                else if (response.data.order && response.data.orderStatus === 'success' && response.data.order.length > 0 && orderingMore) {
                    setHasExistingTableOrder(true);
                    setOrderedItemQuantities(response.data.orderedItemQuantities || {});
                    setOrderedCategoryQuantities(response.data.orderedCategoryQuantities || {});
                    if (response.data.guestCount) {
                        setDineInGuestCount(response.data.guestCount);
                    }
                    
                    if (response.data.disableOrderTracking === 1) {
                        
                        setHasUnpaidOrder(false);
                    }
                    else{
                        setHasUnpaidOrder(true);
                         // 重置 location state 中的 orderingMore 为 false
                         navigate(location.pathname, { 
                            state: { 
                                ...locationState, 
                                orderingMore: false 
                            }, 
                            replace: true 
                        });
                        //reset location state, orderMore to false

                    }
                }
                else if (response.data.order && response.data.orderStatus === 'success' && response.data.order.length > 0 && !orderingMore) {
                    setHasExistingTableOrder(true);
                    setOrderedItemQuantities(response.data.orderedItemQuantities || {});
                    setOrderedCategoryQuantities(response.data.orderedCategoryQuantities || {});
                    if (response.data.guestCount) {
                        setDineInGuestCount(response.data.guestCount);
                    }
                    if (response.data.disableOrderTracking === 1) {
                        
                        setHasUnpaidOrder(false);
                    }
                    else{
                        setHasUnpaidOrder(true);
                        navigate(`/qr_order/${restaurantUrl}/${tableNo}/orderReview`, { state: {} });
                    }
                    

                }
                else {
                    setOrderedItemQuantities(response.data.orderedItemQuantities || {});
                    setOrderedCategoryQuantities(response.data.orderedCategoryQuantities || {});
                    if (response.data.guestCount) {
                        setDineInGuestCount(response.data.guestCount);
                    }
                }
            } catch (error) {
                console.error('Error fetching table order:', error);
            }
        };
   
        if (iconloading) {
            fetchStoreConfig();
            if (tableNo.toLowerCase() !== 'take_away' && tableNo !== 'Take-away') {
                fetchTableOrder();
 
            }
            
        }
    }, [restaurantUrl, tableNo, tableNumber, iconloading]);

    useEffect(() => {
        if (!iconloading || !isDineInTable) return;

        const syncLatestGuestState = () => {
            refreshDineInGuestState().catch(error => {
                console.error('Error refreshing dine-in guest count:', error);
            });
        };
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                syncLatestGuestState();
            }
        };

        window.addEventListener('focus', syncLatestGuestState);
        window.addEventListener('pageshow', syncLatestGuestState);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            window.removeEventListener('focus', syncLatestGuestState);
            window.removeEventListener('pageshow', syncLatestGuestState);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [restaurantUrl, tableNo, iconloading, isDineInTable]);

    // Promotion countdown timer
    useEffect(() => {
        let timer;
        if (showPromotionPopup && countdown > 0) {
            timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);
        } else if (showPromotionPopup && countdown === 0) {
            setShowPromotionPopup(false);
            setCountdown(10); // Reset for next time
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [showPromotionPopup, countdown]);


    // 切换语言并互换描述

    const toggleLanguage = (index) => {
       
        if (String(index) === String(language)) {
         
            toggleLanguagepopup(false);
            return;
        }
        else{
            setLanguage(index)
            if (index === 0) {
                setUILanguage(firstLanguage);
                setUiLanguage(firstLanguage);
            }
            else{
                setUILanguage(secondLanguage);
                setUiLanguage(secondLanguage);
            }
            swapDescriptions();
            toggleLanguagepopup(false);
        }
        
      
    };
    


    function getLanguageLocalName(languageCode) {
        
        const languageMap = {
            "en": "English",    // 英文
            "zh": "简体中文",        // 简体中文
            "zf": "繁體中文",        // 繁体中文
            "ko": "한국어",      // 韩文
            "ja": "日本語",      // 日文
            "vi": "Tiếng Việt", // 越南文
            "th": "ไทย"         // 泰文
        };
    
        return languageMap[languageCode] || languageCode; // 如果找不到匹配项，返回原始代码
    };

    const translations = {
        en: {
            openingHours: "Opening Hours:",
            contactNumber: "Contact Number:",
            learnMore: "Learn more",
            nodishesselected: "No dishes selected",
            seleteddishes: "Selected Dishes",
            clearcart: "Clear Cart",
            checkout: "Check Out",
            fullmenu: "Full Menu",
            selectoptions: "Select Options",
            selectchoices: "Select Choices",
            options: "Options",
            addToCart: "Add to Cart",
            spellInstruction: "Special Instructions",
            maxLimit: "Maximum limit reached",
            itemLimitReached: "Item limit reached",
            itemLimitDetail: "{name} can be ordered up to {max} in total for this table.",
            itemLimitShort: "Limit",
            itemLimitBadge: "{used}/{max} limit",
            guestCountTitle: "Please select guest count",
            guestCountSubtitle: "Please select the current dine-in guest count.",
            guestCountRequired: "Please select the dine-in guest count.",
            guestCountConfirm: "Confirm",
            guestCountCancel: "Cancel",
            guestCountPlus: "6+",
            guestCountPerson: "{count}",
            guestCountPeople: "{count}",
            menuGroupTitle: "Choose your favourite menu",
            menuGroupConfirm: "Confirm",
            menuGroupPerPerson: "/ Person",
            menuGroupRequired: "Please choose a menu",
            menuGroupPopular: "Popular",

            mustBeSelected: "Please select the required number of items to continue.",
            maxLimitDetail: "You cannot select more than {max} dishes.",
            partner_ordered_title: "Partner Just Ordered",
            partner_ordered_typewriter: "Partner just ordered one...",



        },

        ja: {
            openingHours: "営業時間：",
            learnMore: "詳細を見る",
            nodishesselected: "選択された料理はありません",
            seleteddishes: "選択された料理",
            clearcart: "カートを空にする",
            checkout: "チェックアウト",
            fullmenu: "フルメニュー",
            selectoptions: "オプションを選択",
            selectchoices: "選択肢を選択",
            options: "オプション",
            addToCart: "カートに追加",
            spellInstruction: "特別な指示",
            maxLimit: "最大制限に達しました",
            itemLimitReached: "注文上限に達しました",
            itemLimitDetail: "{name}はこのテーブルで合計{max}点まで注文できます。",
            itemLimitShort: "上限",
            itemLimitBadge: "{used}/{max} 上限",
            guestCountTitle: "人数を選択",
            guestCountSubtitle: "現在の店内飲食人数を選択してください。",
            guestCountRequired: "店内飲食人数を選択してください。",
            guestCountConfirm: "確認",
            guestCountCancel: "キャンセル",
            guestCountPlus: "6名以上",
            guestCountPerson: "{count}名",
            guestCountPeople: "{count}名",
            menuGroupTitle: "お好みのメニューを選択",
            menuGroupConfirm: "確認",
            menuGroupPerPerson: "/名",
            menuGroupRequired: "メニューを選択してください",
            menuGroupPopular: "おすすめ",
            mustBeSelected: "続行するには、必要な数のアイテムを選択してください。",
            maxLimitDetail: "選択できる料理の数は{max}を超えることはできません。",
            partner_ordered_title: "仲間が注文しました",
            partner_ordered_typewriter: "仲間がたった今1品注文しました...",

        },
        zh: {
            openingHours: "营业时间：",
            learnMore: "了解更多",
            nodishesselected: "未选择任何菜品",
            seleteddishes: "已选菜品",
            clearcart: "清空购物车",
            checkout: "下单",
            fullmenu: "菜单",
            selectoptions: "菜品选项",
            selectchoices: "选项",
            options: "选规格",
            addToCart: "加入购物车",
            spellInstruction: "特殊要求",
            maxLimit: "已达到最大限制",
            itemLimitReached: "已达到限点数量",
            itemLimitDetail: "{name} 本桌最多可点 {max} 份。",
            itemLimitShort: "已达上限",
            itemLimitBadge: "已点 {used}/{max}",
            guestCountTitle: "选择就餐人数",
            guestCountSubtitle: "请选择当前就餐人数，便于为您推荐合适的菜品",
            guestCountRequired: "请选择就餐人数",
            guestCountConfirm: "确定",
            guestCountCancel: "取消",
            guestCountPlus: "6人及以上",
            guestCountPerson: "{count}人",
            guestCountPeople: "{count}人",
            menuGroupTitle: "选择喜爱的菜单",
            menuGroupConfirm: "确认",
            menuGroupPerPerson: "/人",
            menuGroupRequired: "请选择一个菜单",
            menuGroupPopular: "推荐",
            mustBeSelected: "请选定所需数量的菜品以继续。",
            maxLimitDetail: "您最多只能选择{max}道菜。",
            partner_ordered_title: "伙伴已点餐",
            partner_ordered_typewriter: "伙伴刚刚点了一份..."


        },
        zf: {
            openingHours: "營業時間：",
            learnMore: "了解更多",
            nodishesselected: "未選擇任何菜品",
            seleteddishes: "已選菜品",
            clearcart: "清空購物車",
            checkout: "下單",
            fullmenu: "菜單",
            selectoptions: "菜品選項",
            selectchoices: "選項",
            options: "選規格",
            addToCart: "加入購物車",
            spellInstruction: "特殊要求",
            maxLimit: "已達到最大限制",
            itemLimitReached: "已達到限點數量",
            itemLimitDetail: "{name} 本桌最多可點 {max} 份。",
            itemLimitShort: "已達上限",
            itemLimitBadge: "已點 {used}/{max}",
            guestCountTitle: "選擇就餐人數",
            guestCountSubtitle: "請選擇目前就餐人數，便於為您推薦合適的菜品",
            guestCountRequired: "請選擇就餐人數",
            guestCountConfirm: "確定",
            guestCountCancel: "取消",
            guestCountPlus: "6人及以上",
            guestCountPerson: "{count}人",
            guestCountPeople: "{count}人",
            menuGroupTitle: "選擇喜愛的菜單",
            menuGroupConfirm: "確認",
            menuGroupPerPerson: "/人",
            menuGroupRequired: "請選擇一個菜單",
            menuGroupPopular: "推薦",
            mustBeSelected: "請選定所需數量的菜品以繼續。",
            maxLimitDetail: "您最多只能選擇{max}道菜。",
            partner_ordered_title: "夥伴已點餐",
            partner_ordered_typewriter: "夥伴剛剛點了一份..."
        },
        ko: {
            openingHours: "영업 시간:",
            learnMore: "더 알아보기",
            nodishesselected: "선택된 요리가 없습니다",
            seleteddishes: "선택된 요리",
            clearcart: "장바구니 비우기",
            checkout: "결제",
            fullmenu: "전체 메뉴",
            selectoptions: "옵션 선택",
            selectchoices: "선택",
            options: "옵션",
            addToCart: "장바구니에 추가",
            spellInstruction: "특별한 지시",   
            maxLimit: "최대 제한에 도달했습니다",
            itemLimitReached: "주문 한도에 도달했습니다",
            itemLimitDetail: "{name}은 이 테이블에서 총 {max}개까지 주문할 수 있습니다.",
            itemLimitShort: "한도",
            itemLimitBadge: "{used}/{max} 한도",
            guestCountTitle: "인원 선택",
            guestCountSubtitle: "현재 매장 식사 인원을 선택해주세요.",
            guestCountRequired: "매장 식사 인원을 선택해주세요.",
            guestCountConfirm: "확인",
            guestCountCancel: "취소",
            guestCountPlus: "6명 이상",
            guestCountPerson: "{count}명",
            guestCountPeople: "{count}명",
            menuGroupTitle: "원하는 메뉴 선택",
            menuGroupConfirm: "확인",
            menuGroupPerPerson: "/인",
            menuGroupRequired: "메뉴를 선택해주세요",
            menuGroupPopular: "추천",
            mustBeSelected: "계속하려면 필요한 수의 항목을 선택하십시오." ,
            maxLimitDetail: "선택할 수 있는 요리 수는 {max}개를 초과할 수 없습니다.",
            partner_ordered_title: "동행이 주문했어요",
            partner_ordered_typewriter: "동행이 방금 하나 주문했어요..."

        },
    
        vi: {
            openingHours: "Giờ mở cửa:",
            learnMore: "Tìm hiểu thêm",
            nodishesselected: "Không có món ăn nào được chọn",
            seleteddishes: "Món đã chọn",
            clearcart: "Xóa giỏ hàng",
            checkout: "Thanh toán",
            fullmenu: "Toàn bộ menu",
            selectoptions: "Chọn tùy chọn",
            selectchoices: "Chọn",
            options: "Tùy chọn",
            addToCart: "Thêm vào giỏ hàng",
            spellInstruction: "Hướng dẫn đặc biệt",
            maxLimit: "Đã đạt đến giới hạn tối đa",
            itemLimitReached: "Đã đạt giới hạn món",
            itemLimitDetail: "{name} chỉ có thể đặt tối đa {max} món cho bàn này.",
            itemLimitShort: "Giới hạn",
            itemLimitBadge: "{used}/{max} giới hạn",
            guestCountTitle: "Chọn số khách",
            guestCountSubtitle: "Vui lòng chọn số khách dùng bữa tại bàn.",
            guestCountRequired: "Vui lòng chọn số khách.",
            guestCountConfirm: "Xác nhận",
            guestCountCancel: "Hủy",
            guestCountPlus: "6+",
            guestCountPerson: "{count} khách",
            guestCountPeople: "{count} khách",
            menuGroupTitle: "Chọn menu yêu thích",
            menuGroupConfirm: "Xác nhận",
            menuGroupPerPerson: "/ khách",
            menuGroupRequired: "Vui lòng chọn một menu",
            menuGroupPopular: "Phổ biến",
            mustBeSelected: "Vui lòng chọn số lượng cần thiết để tiếp tục.",
            maxLimitDetail: "Bạn không thể chọn nhiều hơn {max} món.",
            partner_ordered_title: "Bạn đồng hành vừa đặt món",
            partner_ordered_typewriter: "Bạn đồng hành vừa gọi một món..."

        },
        th: {
            openingHours: "เวลาเปิด-ปิด:",
            learnMore: "เรียนรู้เพิ่มเติม",
            nodishesselected: "ไม่มีเมนูที่เลือก",
            seleteddishes: "เมนูที่เลือก",
            clearcart: "ล้างตะกร้า",
            checkout: "ชำระเงิน",
            fullmenu: "เมนูเต็ม",
            selectoptions: "เลือกตัวเลือก",
            selectchoices: "เลือก",
            options: "ตัวเลือก",
            addToCart: "เพิ่มลงในตะกร้า",
            spellInstruction: "คำแนะนำพิเศษ",
            maxLimit: "เกินขีดจำกัดสูงสุด",
            itemLimitReached: "ถึงขีดจำกัดรายการแล้ว",
            itemLimitDetail: "{name} สามารถสั่งได้สูงสุด {max} รายการสำหรับโต๊ะนี้",
            itemLimitShort: "จำกัด",
            itemLimitBadge: "{used}/{max} จำกัด",
            guestCountTitle: "เลือกจำนวนผู้เข้าพัก",
            guestCountSubtitle: "โปรดเลือกจำนวนผู้เข้าพักสำหรับทานในร้าน",
            guestCountRequired: "โปรดเลือกจำนวนผู้เข้าพัก",
            guestCountConfirm: "ยืนยัน",
            guestCountCancel: "ยกเลิก",
            guestCountPlus: "6+",
            guestCountPerson: "{count} คน",
            guestCountPeople: "{count} คน",
            menuGroupTitle: "เลือกเมนูที่ชอบ",
            menuGroupConfirm: "ยืนยัน",
            menuGroupPerPerson: "/ คน",
            menuGroupRequired: "โปรดเลือกเมนู",
            menuGroupPopular: "แนะนำ",
            mustBeSelected: "โปรดเลือกจำนวนที่ต้องการเพื่อดำเนินการต่อ",
            maxLimitDetail: "คุณไม่สามารถเลือกมากกว่า {max} รายการ",
            partner_ordered_title: "เพื่อนของคุณเพิ่งสั่ง",
            partner_ordered_typewriter: "เพื่อนของคุณเพิ่งสั่งหนึ่งรายการ..."

        }
    
        // 其他语言的翻译...
    };
    //   const ui = (key) => translations[UILanguage][key] || translations['en'][key];       
    const ui = (key, vars = {}) => {
        let text = translations[UILanguage][key] || translations['en'][key] || key;
        Object.keys(vars).forEach(k => {
            text = text.replace(`{${k}}`, vars[k]);
        });
        return text;
    };

    const needsGuestCount = (guestState = null) => {
        if (guestState) {
            return Boolean(guestState.shouldRequireGuestCount && isDineInTable && !guestState.tableHasExistingOrder && !guestState.hasServerGuestCount);
        }
        return Boolean(requireDineInGuestCount && isDineInTable && !hasExistingTableOrder && !serverHasDineInGuestCount);
    };

    const openGuestCountPopupIfNeeded = (guestState = null) => {
        const hasServerGuestCount = guestState ? guestState.hasServerGuestCount : serverHasDineInGuestCount;
        const activeGuestCount = Number(guestState ? guestState.guestCount : dineInGuestCount);
        if (hasServerGuestCount && activeGuestCount > 0) {
            setSelectedGuestCount(activeGuestCount);
            setCustomGuestCount(activeGuestCount > 5 ? String(activeGuestCount) : '');
            setCustomGuestCountMode(activeGuestCount > 5);
            return false;
        }
        if (needsGuestCount(guestState)) {
            const nextCount = 2;
            setSelectedGuestCount(nextCount);
            setCustomGuestCount(nextCount > 5 ? String(nextCount) : '');
            setCustomGuestCountMode(nextCount > 5);
            setShowGuestCountPopup(true);
            return true;
        }
        return false;
    };

    const openMenuGroupPopupIfNeeded = (options = menuGroupOptions) => {
        if (!menuGroupSelectionEnabled || !Array.isArray(options) || options.length === 0) {
            return false;
        }
        if (cart.length > 0 || hasExistingTableOrder || gethasUnpaidOrder()) {
            return false;
        }
        if (selectedMenuGroupCode || menuGroupSelectionSkipped) {
            return false;
        }
        setShowMenuGroupPopup(true);
        return true;
    };

    const showPromotionIfNeeded = (delay = 250) => {
        if (promotionEnabled) {
            setTimeout(() => {
                setShowPromotionPopup(true);
                setCountdown(10);
            }, delay);
        }
    };

    const continueAfterStartupGate = (options = menuGroupOptions) => {
        const menuGroupPopupOpened = openMenuGroupPopupIfNeeded(options);
        if (!menuGroupPopupOpened) {
            showPromotionIfNeeded();
        }
    };

    const handleMenuGroupSelect = (group) => {
        setSelectedMenuGroupCode(group.Code);
        setPendingMenuGroupCode(group.Code);
        setMenuGroupSelectionSkipped(false);
        sessionStorage.setItem(menuGroupSelectionKey, group.Code);
        setShowMenuGroupPopup(false);
        setFetchDataTag((prev) => !prev);
        showPromotionIfNeeded();
    };

    const confirmMenuGroupSelect = () => {
        const group = menuGroupOptions.find((item) => item.Code === pendingMenuGroupCode);
        if (!group) {
            notification.warning({
                message: ui('menuGroupRequired'),
                ...warningPlacement,
            });
            return;
        }
        handleMenuGroupSelect(group);
    };

    const handleMenuGroupSkip = () => {
        setSelectedMenuGroupCode('');
        setPendingMenuGroupCode('');
        setMenuGroupSelectionSkipped(true);
        sessionStorage.setItem(menuGroupSelectionKey, '__skip__');
        setShowMenuGroupPopup(false);
        setFetchDataTag((prev) => !prev);
        showPromotionIfNeeded();
    };

    const saveGuestCount = async (guestCount = selectedGuestCount) => {
        const parsedGuestCount = Number.parseInt(guestCount, 10);
        if (!Number.isInteger(parsedGuestCount) || parsedGuestCount <= 0) {
            notification.warning({
                message: ui('guestCountRequired'),
                ...warningPlacement,
            });
            return;
        }
        try {
            await axios.post(`${process.env.REACT_APP_SERVER_URL}/set-dine-in-guest-count/${restaurantUrl}`, {
                tableNumber: tableNo,
                guestCount: parsedGuestCount,
            });
        } catch (error) {
            console.error('Error saving dine-in guest count:', error);
            notification.warning({
                message: ui('guestCountRequired'),
                ...warningPlacement,
            });
            return;
        }
        setDineInGuestCount(parsedGuestCount);
        setServerHasDineInGuestCount(true);
        setSelectedGuestCount(parsedGuestCount);
        setCustomGuestCountMode(parsedGuestCount > 5);
        setCustomGuestCount(parsedGuestCount > 5 ? String(parsedGuestCount) : '');
        setShowGuestCountPopup(false);
        if (showPromotionAfterGuestCount) {
            setShowPromotionAfterGuestCount(false);
            continueAfterStartupGate();
        }
    };

    const guestCountOptions = [1, 2, 3, 4, 5];
    const isCustomGuestCountSelected = customGuestCountMode || selectedGuestCount > 5;
    const getGuestCountToSave = () => {
        if (isCustomGuestCountSelected) {
            const parsedCustomGuestCount = Number.parseInt(customGuestCount, 10);
            return Number.isInteger(parsedCustomGuestCount) && parsedCustomGuestCount >= 6
                ? parsedCustomGuestCount
                : null;
        }
        return selectedGuestCount;
    };
    const guestCountLabel = (count) => ui(count === 1 ? 'guestCountPerson' : 'guestCountPeople', { count });

    const getPartnerDishName = (partnerEvent) => {
        if (!partnerEvent || !partnerEvent.mainItem) {
            return '';
        }

        const primaryName = partnerEvent.mainItem.mainItemDescription || '';
        const secondaryName = partnerEvent.mainItem.mainItemDescription1 || '';

        return Number(language) === 1
            ? (secondaryName || primaryName)
            : (primaryName || secondaryName);
    };
    

    

    const swapDescriptions = () => {

        const swappedMainCategories = {};
        Object.values(mainCategories).forEach(categoryItems => {
            categoryItems.forEach(item => {
                // 使用 Category1 作为键，如果不存在，则使用 Category
                const categoryKey = item.Category1 || item.Category; 
                if (!swappedMainCategories[categoryKey]) {
                    swappedMainCategories[categoryKey] = [];
                }
                swappedMainCategories[categoryKey].push({
                    ...item,
                    Category: item.Category1,
                    Category1: item.Category,
                    Description1: item.Description2,
                    Description2: item.Description1,
                    TagDescription: item.TagDescription1,
                    TagDescription1: item.TagDescription
                });
            });
        });
    
        setMainCategories(swappedMainCategories);
    
        const swappedSubmenuData = submenuData.map(item => ({
            ...item,
            Description1: item.Description2,
            Description2: item.Description1
        }));
        setSubmenuData(swappedSubmenuData);
      
    
        setCategoryList(Object.keys(swappedMainCategories));
        setSelectedCategory(Object.keys(swappedMainCategories)[0]);

        swapDescriptionsInCart();
        

    };

    const swapMenu = (mainCategoriesData,submenuLinkData ) => {

       

        const swappedMainCategories = {};
        Object.values(mainCategoriesData).forEach(categoryItems => {
            categoryItems.forEach(item => {
                // 使用 Category1 作为键，如果不存在，则使用 Category
                const categoryKey = item.Category1 || item.Category; 
                if (!swappedMainCategories[categoryKey]) {
                    swappedMainCategories[categoryKey] = [];
                }
                swappedMainCategories[categoryKey].push({
                    ...item,
                    Category: item.Category1,
                    Category1: item.Category,
                    Description1: item.Description2,
                    Description2: item.Description1,
                    TagDescription: item.TagDescription1,
                    TagDescription1: item.TagDescription
                });
            });
        });
    
        setMainCategories(swappedMainCategories);
    
        const swappedSubmenuData = submenuLinkData.map(item => ({
            ...item,
            Description1: item.Description2,
            Description2: item.Description1
        }));
        setSubmenuData(swappedSubmenuData);
      
    
        setCategoryList(Object.keys(swappedMainCategories));
        setSelectedCategory(Object.keys(swappedMainCategories)[0]);

        // swapDescriptionsInCart();

    };
    
    
    



    // 获取商店位置的函数
    const fetchStoreLocation = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/fetchStoreLocation/${restaurantUrl}`);
          
            return response.data.storeCoordLocation; // 假设location包含经纬度
        } catch (error) {
            console.error('Error fetching store location:', error);
        }
    };

            



     // 获取用户位置并比较的函数
     const getUserLocationAndCompare = (LocationRange) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const  storeCoords = await fetchStoreLocation();
                    const distance = calculateDistance(position.coords, storeCoords);
              
                    if (distance > LocationRange) {
                        setLocationValid(false);
                        navigate('/warning'); // 跳转到其他页面
                    }
                    else{
                        setLocationValid(true);
                        navigate(`/qr_order/${restaurantUrl}/order`);
                    }
                },
                (err) => {
                    setLocationValid(false);
                    navigate('/warning')
                    
                }
            );
        } else {
            setLocationValid(false);
            navigate('/warning')
        }
    };


  const calculateDistance = (coords1, coords2 ) => {

    const lat1 = coords1.latitude;
    const lon1 = coords1.longitude;
    
    const lat2 = parseFloat(coords2.StoreLatitude);
    const lon2 = parseFloat(coords2.StoreLongitude);
    

    
    const R = 6371; // 地球半径，单位千米
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c * 1000;
};




    const [itemCounts, setItemCounts] = useState({});
    const increaseItemCount = (menuItem) => {
        if (showCooldownMessage(menuItem)) {
            return;
        }
        const itemQuantity = Number(menuItem.DefaultQty) || 1;
        if (!canAddMenuItemQuantity(menuItem, itemQuantity)) {
            return;
        }
        
        const cartItemFormat = {
            mainItemCode: menuItem.ItemCode,
            mainItemDescription: menuItem.Description1,
            mainItemDescription1: menuItem.Description2,
            quantity: itemQuantity,
            price: menuItem.Price,
            taxrate: menuItem.TaxRate,
            orderCooldownSeconds: Number(menuItem.OrderCooldownSeconds) || 0,
            perPersonLimit: Number(menuItem.PerPersonLimit) || 0,
            categoryCode: menuItem.CategoryCode,
            category: menuItem.Category,
            categoryPerPersonLimit: Number(menuItem.CategoryPerPersonLimit) || 0,
            menuGroup: menuItem.MenuGroup,
            multiplePricePosition: 0// 假设 Multiple 字段与 multiplePricePosition 相关
        };
        
        handleAddToContextCart([cartItemFormat]);
    };
    const decreaseItemCount = (menuItem) => {
        
        removeOrderFromCart([100,{
            mainItemCode: menuItem.ItemCode,
            mainItemDescription: menuItem.Description1,
            mainItemDescription1: menuItem.Description2,
            quantity: menuItem.DefaultQty,
            price: menuItem.Price,
            taxrate: menuItem.TaxRate,
            orderCooldownSeconds: Number(menuItem.OrderCooldownSeconds) || 0,
            perPersonLimit: Number(menuItem.PerPersonLimit) || 0,
            categoryCode: menuItem.CategoryCode,
            category: menuItem.Category,
            categoryPerPersonLimit: Number(menuItem.CategoryPerPersonLimit) || 0,
            menuGroup: menuItem.MenuGroup,
            multiplePricePosition: 0// 假设 Multiple 字段与 multiplePricePosition 相关
        }]);
    };

    const isTakeawayTable = (value) => {
        if (!value) return false;
        const normalized = String(value).toLowerCase();
        return normalized === 'take_away' || normalized === 'take-away';
    };

    const getCooldownSeconds = (menuItem) => Number(menuItem?.OrderCooldownSeconds) || 0;
    const getCooldownRemaining = (itemCode) => Number(menuItemCooldowns[itemCode]) || 0;
    const isCoolingDown = (itemCode) => getCooldownRemaining(itemCode) > 0;

    const getRememberedMenuItemCooldowns = () => {
        try {
            const raw = sessionStorage.getItem('menuItemCooldowns');
            if (!raw) return {};
            const remembered = JSON.parse(raw);
            if (String(remembered.storeId) !== String(storeId) || String(remembered.tableNumber) !== String(tableNo)) {
                return {};
            }
            const now = Date.now();
            const next = {};
            (remembered.items || []).forEach(item => {
                const remaining = Math.ceil((Number(item.expiresAt) - now) / 1000);
                if (remaining > 0) {
                    next[item.itemCode] = remaining;
                }
            });
            if (Object.keys(next).length === 0) {
                sessionStorage.removeItem('menuItemCooldowns');
            }
            return next;
        } catch {
            sessionStorage.removeItem('menuItemCooldowns');
            return {};
        }
    };

    const showCooldownMessage = (item) => {
        const remaining = getCooldownRemaining(item.ItemCode);
        if (remaining > 0) {
            notification.warning({
                message: 'Item cooling down',
                description: `${item.Description1 || item.Description2 || item.ItemCode} will be available in ${remaining}s.`,
                ...warningPlacement,
            });
            return true;
        }
        return false;
    };

    const getCartOrderMainItem = (order) => {
        if (!order) return null;
        if (Array.isArray(order)) {
            if (order[1]?.mainItemCode) return order[1];
            if (order[0]?.mainItemCode) return order[0];
            return null;
        }
        return order.mainItemCode ? order : null;
    };

    const getCartMainItemTotalQuantity = (itemCode) => cart.reduce((total, order) => {
        const mainItem = getCartOrderMainItem(order);
        if (!mainItem || String(mainItem.mainItemCode) !== String(itemCode)) {
            return total;
        }
        return total + (Number(mainItem.quantity) || 0);
    }, 0);

    const getCartMainCategoryTotalQuantity = (categoryCode, excludedItemCode = null, excludedQuantity = 0) => {
        const totalQuantity = cart.reduce((total, order) => {
            const mainItem = getCartOrderMainItem(order);
            if (!mainItem || !categoryCode || String(mainItem.categoryCode) !== String(categoryCode)) {
                return total;
            }
            return total + (Number(mainItem.quantity) || 0);
        }, 0);
        if (!excludedItemCode) {
            return totalQuantity;
        }
        return Math.max(0, totalQuantity - (Number(excludedQuantity) || 0));
    };

    const getOrderedItemQuantity = (itemCode) => Number(orderedItemQuantities[String(itemCode)] || orderedItemQuantities[itemCode] || 0);
    const getOrderedCategoryQuantity = (categoryCode) => Number(orderedCategoryQuantities[String(categoryCode)] || orderedCategoryQuantities[categoryCode] || 0);
    const getMenuItemPerPersonLimit = (menuItem) => Number(menuItem?.PerPersonLimit ?? menuItem?.perPersonLimit) || 0;
    const getCategoryPerPersonLimit = (menuItem) => Number(menuItem?.CategoryPerPersonLimit ?? menuItem?.categoryPerPersonLimit) || 0;
    const getMenuItemName = (menuItem) => menuItem?.Description1 || menuItem?.Description || menuItem?.Description2 || menuItem?.ItemCode || menuItem?.MainItemCode || '';
    const getMenuItemCode = (menuItem) => menuItem?.ItemCode || menuItem?.MainItemCode || menuItem?.mainItemCode;
    const getMenuItemCategoryCode = (menuItem) => menuItem?.CategoryCode || menuItem?.categoryCode;
    const getMenuItemCategoryName = (menuItem) => menuItem?.Category || menuItem?.category || getMenuItemName(menuItem);

    const getPerPersonLimitStates = (menuItem, quantityToAdd = 0, excludedCartQuantity = 0) => {
        const itemCode = getMenuItemCode(menuItem);
        const perPersonLimit = getMenuItemPerPersonLimit(menuItem);
        const categoryCode = getMenuItemCategoryCode(menuItem);
        const categoryPerPersonLimit = getCategoryPerPersonLimit(menuItem);
        const guestCount = Number(dineInGuestCount) || 0;
        if ((!itemCode && !categoryCode) || guestCount <= 0 || !isDineInTable) {
            return [];
        }
        const states = [];
        if (itemCode && perPersonLimit > 0) {
            const maxQuantity = perPersonLimit * guestCount;
            const existingQuantity = getOrderedItemQuantity(itemCode);
            const cartQuantity = Math.max(0, getCartMainItemTotalQuantity(itemCode) - (Number(excludedCartQuantity) || 0));
            const requestedQuantity = existingQuantity + cartQuantity + (Number(quantityToAdd) || 0);
            states.push({
                limited: true,
                type: 'item',
                itemCode,
                maxQuantity,
                existingQuantity,
                cartQuantity,
                requestedQuantity,
                remainingQuantity: Math.max(0, maxQuantity - existingQuantity - cartQuantity),
                overLimit: requestedQuantity > maxQuantity,
            });
        }
        if (categoryCode && categoryPerPersonLimit > 0) {
            const maxQuantity = categoryPerPersonLimit * guestCount;
            const existingQuantity = getOrderedCategoryQuantity(categoryCode);
            const cartQuantity = Math.max(0, getCartMainCategoryTotalQuantity(categoryCode, itemCode, excludedCartQuantity));
            const requestedQuantity = existingQuantity + cartQuantity + (Number(quantityToAdd) || 0);
            states.push({
                limited: true,
                type: 'category',
                categoryCode,
                categoryName: getMenuItemCategoryName(menuItem),
                maxQuantity,
                existingQuantity,
                cartQuantity,
                requestedQuantity,
                remainingQuantity: Math.max(0, maxQuantity - existingQuantity - cartQuantity),
                overLimit: requestedQuantity > maxQuantity,
            });
        }
        return states;
    };

    const getPerPersonLimitState = (menuItem, quantityToAdd = 0, excludedCartQuantity = 0) => {
        const states = getPerPersonLimitStates(menuItem, quantityToAdd, excludedCartQuantity);
        return states.find(state => state.overLimit) || states[0] || { limited: false };
    };

    const getPerPersonLimitBadgeState = (menuItem) => {
        const states = getPerPersonLimitStates(menuItem, 0);
        if (states.length === 0) {
            return { limited: false };
        }
        return [...states].sort((a, b) => {
            if (a.overLimit !== b.overLimit) {
                return a.overLimit ? -1 : 1;
            }
            const remainingDiff = Number(a.remainingQuantity) - Number(b.remainingQuantity);
            if (remainingDiff !== 0) {
                return remainingDiff;
            }
            return a.type === 'item' ? -1 : 1;
        })[0];
    };

    const showPerPersonLimitMessage = (menuItem, limitState) => {
        notification.warning({
            message: ui('itemLimitReached'),
            description: ui('itemLimitDetail', {
                name: limitState?.type === 'category' ? getMenuItemCategoryName(menuItem) : getMenuItemName(menuItem),
                max: limitState?.maxQuantity || 0,
            }),
            ...warningPlacement,
        });
    };

    const canAddMenuItemQuantity = (menuItem, quantityToAdd = 1, excludedCartQuantity = 0) => {
        const limitState = getPerPersonLimitStates(menuItem, quantityToAdd, excludedCartQuantity).find(state => state.overLimit) || { limited: false };
        if (limitState.overLimit) {
            showPerPersonLimitMessage(menuItem, limitState);
            return false;
        }
        return true;
    };

    const isMenuItemAtPerPersonLimit = (menuItem) => {
        const limitState = getPerPersonLimitState(menuItem, 1);
        return Boolean(limitState.overLimit);
    };

    const getPerPersonLimitBadgeText = (limitState) => ui('itemLimitBadge', {
        used: Math.min(limitState.existingQuantity + limitState.cartQuantity, limitState.maxQuantity),
        max: limitState.maxQuantity,
    });

    const shouldShowPerPersonLimitBadge = (limitState) => (
        Boolean(limitState.limited) &&
        (
            limitState.type === 'item' ||
            limitState.overLimit ||
            (Number(limitState.existingQuantity) + Number(limitState.cartQuantity)) > 0
        )
    );

    useEffect(() => {
        const timer = setInterval(() => {
            setMenuItemCooldowns(prev => {
                const next = {};
                Object.entries(prev).forEach(([itemCode, seconds]) => {
                    const remaining = Number(seconds) - 1;
                    if (remaining > 0) {
                        next[itemCode] = remaining;
                    }
                });
                return next;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const popUpIncreaseItemCount = (order) => {
        const mainItem = getCartOrderMainItem(order);
        if (!mainItem || !canAddMenuItemQuantity(mainItem, 1)) {
            return;
        }
        editaddOrderToCart(order);
    }

 
    const handleAddToContextCart = (item) => {

        addOrderToCart(item);
        
    };


    

    const [totalItemCount, setTotalItemCount] = useState(0); // 总菜品数量
    const [imagesLoaded, setImagesLoaded] = useState(false); // 新增状态跟踪图片加载情况
    const [loadedImagesCount, setLoadedImagesCount] = useState(0); // 跟踪已加载的图片数量
    
    

    const handleImageLoad = () => {
        setLoadedImagesCount(prevCount => prevCount + 1);
    };
    useEffect(() => {
        
        if (loadedImagesCount === totalItemCount) { // 所有图片已加载

            const elapsedTime = new Date().getTime() - startTime; // 计算已经过去的时间
            if (elapsedTime < 2000) { // 如果少于 2 秒
                setTimeout(() => {
                    setImagesLoaded(true);
                }, 2000 - elapsedTime); // 延迟至总时间达到 2 秒
            } else {
                setImagesLoaded(true); // 如果已经超过 2 秒，则立即显示
            }
        }
    }, [loadedImagesCount, totalItemCount]);

    // 在组件加载时记录开始时间
    const [startTime, setStartTime] = useState(new Date().getTime());
    useEffect(() => {
        setStartTime(new Date().getTime()); // 设置开始加载的时间
    }, []);

    useEffect(() => {
        // 预加载的图片路径列表
        const imagePaths = ['/img/icon7.svg','/img/icon1.svg','/img/food-grey.svg','/img/food.svg', '/img/icon10.svg', '/img/icon11.svg', '/img/icon6.svg', '/img/icon8.svg', '/img/icon3.svg', 
        '/img/plus-black-bold.svg', '/img/minus-black-bold.svg', '/img/blank.jpeg','/img/arrow-up.png','/img/arrow-down.png'
     ];

        let imagesLoaded = 0; // 记录加载完成的图片数量
        const totalImages = imagePaths.length; // 图片总数量
    
        // 更新加载状态的函数
        const checkIfAllImagesLoaded = () => {
            imagesLoaded += 1;
            if (imagesLoaded === totalImages) {
                setIconloading(true); // 当所有图片都加载完成时更新状态
            }
        };
    
        imagePaths.forEach(path => {
            const img = new Image();
            img.src = path;
            img.onload = checkIfAllImagesLoaded; // 当图片加载完成时执行的函数
        });
    }, []);

    useEffect(() => {
        const fetchMenuList = async () => {
            let serviceType = 0;
            if (tableNo === 'take_away'|| tableNo === 'Take-away') {
                serviceType = 1;
            }
            const params = selectedMenuGroupCode ? { menuGroupCode: selectedMenuGroupCode } : {};
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/fetchMenuList/${restaurantUrl}/${serviceType}`, { params });
            const imageVersion = Date.now();
            setMenuImageVersion(imageVersion);
            
            if (Number(response.data.restaurant.StoreId) !== Number(sessionStorage.getItem('storeId'))) {
                sessionStorage.clear();
                clearCart();
            }
          
            setStoreId(response.data.restaurant.StoreId);
            setStoreName(response.data.restaurant.StoreName);
          
            setStoreImg(response.data.restaurant.StoreImgPath);
     
            //console.log(response.data.menuList)

            const { mainCategories, totalItemCount } = menuListDataStructure(response.data.menuList);



            if (currentLanguage===null && language === 1) {
                swapMenu(mainCategories,response.data.subMenuLinks);
            }
            else{
                setMainCategories(mainCategories);
                setCategoryList( Object.keys(mainCategories));
                setSelectedCategory( Object.keys(mainCategories)[0]);
                setSubmenuData(response.data.subMenuLinks);
            }
            setTotalItemCount(totalItemCount);

            // 只预热首屏附近图片，避免一次请求全部菜品图片。
            try {
                const sid = response.data.restaurant.StoreId;
                const serverUrl = process.env.REACT_APP_SERVER_URL;
                const seen = new Set();
                const preloadItems = (items, limit) => {
                    (items || []).slice(0, limit).forEach(item => {
                        if (!item || !item.ItemCode || seen.has(item.ItemCode)) return;
                        seen.add(item.ItemCode);
                        const preImg = new Image();
                        preImg.crossOrigin = 'anonymous';
                        preImg.src = `${serverUrl}/images/${sid}/menuItems/${item.ItemCode}?v=${imageVersion}`;
                    });
                };
                const categoryNames = Object.keys(mainCategories);
                const firstCategoryItems = mainCategories[categoryNames[0]] || [];
                preloadItems(firstCategoryItems, 12);

                const scheduleIdle = window.requestIdleCallback || ((callback) => setTimeout(callback, 350));
                scheduleIdle(() => {
                    preloadItems(firstCategoryItems.slice(12), 12);
                    categoryNames.slice(1, 3).forEach((categoryName) => {
                        preloadItems(mainCategories[categoryName], 6);
                    });
                });
            } catch (e) {
                // 预加载失败不影响主流程
            }
        };
        if (storeConfigTag && iconloading) {
          
            fetchMenuList();
        }
    }, [fetchDataTag, storeConfigTag, iconloading, selectedMenuGroupCode, menuGroupSelectionSkipped]); // 使用 restaurantUrl 作为依赖项

    useEffect(() => {
        if (!selectedCategory || !storeId || !mainCategories[selectedCategory]) {
            return;
        }
        try {
            const currentItems = mainCategories[selectedCategory] || [];
            const categoryNames = Object.keys(mainCategories);
            const selectedIndex = categoryNames.indexOf(selectedCategory);
            const seen = new Set();
            const preloadItems = (items, limit) => {
                (items || []).slice(0, limit).forEach(item => {
                    if (!item || !item.ItemCode || seen.has(item.ItemCode)) return;
                    seen.add(item.ItemCode);
                    const preImg = new Image();
                    preImg.crossOrigin = 'anonymous';
                    preImg.src = menuItemImageUrl(item.ItemCode);
                });
            };
            preloadItems(currentItems, 12);
            const scheduleIdle = window.requestIdleCallback || ((callback) => setTimeout(callback, 350));
            scheduleIdle(() => {
                preloadItems(currentItems.slice(12), 12);
                const previousCategory = categoryNames[selectedIndex - 1];
                const nextCategory = categoryNames[selectedIndex + 1];
                preloadItems(mainCategories[previousCategory], 4);
                preloadItems(mainCategories[nextCategory], 4);
            });
        } catch (e) {
            // 预加载失败不影响主流程
        }
    }, [selectedCategory, storeId, menuImageVersion, mainCategories]);

    useEffect(() => {
        const fetchCooldownState = async () => {
            if (!storeId || isTakeawayTable(tableNo)) {
                setMenuItemCooldowns({});
                return;
            }
            const rememberedCooldowns = getRememberedMenuItemCooldowns();
            if (Object.keys(rememberedCooldowns).length > 0) {
                setMenuItemCooldowns(prev => ({ ...prev, ...rememberedCooldowns }));
            }
            const itemCodes = Object.values(mainCategories)
                .flat()
                .filter(item => getCooldownSeconds(item) > 0)
                .map(item => item.ItemCode);
            if (itemCodes.length === 0) {
                setMenuItemCooldowns({});
                return;
            }
            try {
                await axios.post(`${process.env.REACT_APP_SERVER_URL}/check-menu-item-cooldowns`, {
                    storeId,
                    tableNumber: tableNo,
                    serviceMode: 'Dine-in',
                    itemCodes,
                });
                setMenuItemCooldowns(rememberedCooldowns);
            } catch (error) {
                if (error.response?.status === 409) {
                    const next = {};
                    (error.response.data.items || []).forEach(item => {
                        next[item.itemCode] = item.remainingSeconds;
                    });
                    setMenuItemCooldowns(prev => ({ ...prev, ...rememberedCooldowns, ...next }));
                }
            }
        };
        fetchCooldownState();
    }, [storeId, tableNo, mainCategories]);



    const menuListDataStructure = (menuList) => {
        let totalItemCount = 0; // 初始化总菜品数量
        const mainCategoriesMap = {}; // 用于存储主类别
        // const subCategoriesMap = {}; // 用于存储次类别
        
        menuList.forEach(item => {
            // 处理主类别
    
            const mainCategory = item.Category;
           
            if (item.StartTime === null && item.EndTime === null && item.MenuItemStartTime === null && item.MenuItemEndTime === null) {
                if (!mainCategoriesMap[mainCategory]) {
                    mainCategoriesMap[mainCategory] = {
                        categoryCode: item.CategoryCode,
                        items: []
                    };
                }
                mainCategoriesMap[mainCategory].items.push(item);
            }
            
            else{
                const currentTime = new Date().toLocaleTimeString('en-US', { hour12: false });
               
                // 检查是否在营业时间范围内，支持跨天时间段
                const isInTimeRange = (startTime, endTime, currentTime) => {
                    if (startTime === null && endTime === null) return true;
                    if (startTime === null) return currentTime <= endTime;
                    if (endTime === null) return currentTime >= startTime;
                    
                    // 如果开始时间小于等于结束时间，说明在同一天内
                    if (startTime <= endTime) {
                        return currentTime >= startTime && currentTime <= endTime;
                    } else {
                        // 如果开始时间大于结束时间，说明跨天
                        return currentTime >= startTime || currentTime <= endTime;
                    }
                };
                
                if (
                    isInTimeRange(item.StartTime, item.EndTime, currentTime) &&
                    isInTimeRange(item.MenuItemStartTime, item.MenuItemEndTime, currentTime)
                ) {
                    if (!mainCategoriesMap[mainCategory]) {
                        mainCategoriesMap[mainCategory] = {
                            categoryCode: item.CategoryCode,
                            items: []
                        };
                    }
                    mainCategoriesMap[mainCategory].items.push(item);
                }
                
            }
            
            totalItemCount++;
    
        });
    
        // 对主类别和次类别内的项目分别按 ItemCode 排序
        [mainCategoriesMap].forEach(map => {
            Object.values(map).forEach(category => {
                category.items.sort((a, b) => a.ItemCode - b.ItemCode);
            });
        });
    
        // 按 CategoryCode 对主类别和次类别进行排序
        const sortCategories = (categoriesMap) => {
            return Object.entries(categoriesMap)
                .sort((a, b) => a[1].categoryCode.localeCompare(b[1].categoryCode))
                .reduce((acc, [categoryName, categoryData]) => {
                    acc[categoryName] = categoryData.items;
                    return acc;
                }, {});
        };
    
        const sortedMainCategories = sortCategories(mainCategoriesMap);
        // const sortedSubCategories = sortCategories(subCategoriesMap);
        setSelectedCategory(categoryquery || Object.keys(sortedMainCategories)[0]);
 
        
        return {
            mainCategories: sortedMainCategories,
            // subCategories: sortedSubCategories,
            totalItemCount // 总菜品数量
        };
        
    };

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        // 滚动到相应的菜品位置
        const categoryHeader = document.getElementById(category);
        if (categoryHeader) {
            window.scrollTo({
                top: categoryHeader.offsetTop - 75, // 减去一些像素以便留出一些空间
                behavior: 'smooth' // 平滑滚动
            });
        }
    };
    const handleFullCategoryClick = (category) => {
        setSelectedCategory(category);
        toggleFullCategorypopup();
  
        // 滚动到page_t1中对应的类别位置
        const categoryHeader = document.getElementById(category);
        
        if (categoryHeader) {
            window.scrollTo({
                top: categoryHeader.offsetTop - 75, // 减去一些像素以便留出一些空间
                behavior: 'smooth' // 平滑滚动
            });
        }
    
        // 滚动到icon_popup中对应的类别位置
        const categoryElement = document.getElementById(`page_t1-category-${category}`);
        if (categoryElement) {
            categoryElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        
    };
    

    const [submenupopup, setSubmenupopup] = useState(false);
    const toggleSubmenupopup = () => setSubmenupopup(!submenupopup);
      
    const handleClosePopup = () => {
        
        setSelectedSubmenu(null);
        setSelectedSubmenuItems([]);
        
        setSelectedmainItemQty(1);
        setSelectedTotalPrice(null);
        // updateSelectedPriceByPosition(0);
        setSelectedmainItemPosition(0); // 重置 multiple price position
        setSelectedMultipleButtonPosition(0); // 重置 multiple price 按钮高亮
        setChoiceSelectedSubItemNoList({});
        setShowNoteBox(false);
        setNote('');
        toggleSubmenupopup(); // 切换子菜单弹出窗口的显示状态

        // 隐藏submenu弹出窗口
    };
    

    const debounceTimer = useRef(null);

    const handleScroll = () => {
        // 获取所有分类标题元素
        const categoryHeaders = document.querySelectorAll(".sp_list2 h2");
        // 获取当前滚动位置
        const scrollPosition = window.scrollY + window.innerHeight / 2;

        for (let i = 0; i < categoryHeaders.length; i++) {
            const header = categoryHeaders[i];
            // 获取元素在页面上的位置
            const headerPosition = header.getBoundingClientRect().top + window.scrollY;

            if (scrollPosition >= headerPosition) {
                // 如果滚动位置大于或等于标题位置，则更新 selectedCategory
                setSelectedCategory(header.textContent);
                const categoryElement = document.getElementById(`page_t1-category-${header.textContent}`);
                if (categoryElement) {
                    categoryElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }
        }
    };

    const debouncedHandleScroll = () => {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }
        debounceTimer.current = setTimeout(() => {
            handleScroll();
        }, 100); // 100ms 是防抖动时间，可以根据需要调整
    };

    useEffect(() => {
        window.addEventListener('scroll', debouncedHandleScroll);

        return () => {
            window.removeEventListener('scroll', debouncedHandleScroll);
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }
        };
    }, []); // 确保这个 effect 只在组件加载时运行
    
    const hasSubmenu = (itemId) => {
        return submenuData.some(submenu => submenu.MainItemCode === itemId);
    };

    const handleSelectOptionsClick = (mainItemCode, category, order) => {
        // console.log(order);
        const relatedCategory = mainCategories[category];

        const item = relatedCategory.find(item => item.ItemCode === mainItemCode);
        if (item && showCooldownMessage(item)) {
            return;
        }
        if (item && !order && !canAddMenuItemQuantity(item, 1)) {
            return;
        }
       
        toggleSubmenupopup(); // 切换子菜单弹出窗口的显示状态
      
        // 主项数据
        let submenu = [{
            Category: item.Category,
            CategoryCode: item.CategoryCode,
            Multiple: item.Multiple,
            MainItemCode: item.ItemCode,
            Description: item.Description1,
            Description1: item.Description2,
            TagDescription: item.TagDescription,
            TagDescription1: item.TagDescription1,
            Price: item.Price,
            Price1: item.Price1,
            Price2: item.Price2,
            Price3: item.Price3,
            SubDescription: item.SubDescription,
            SubDescription1: item.SubDescription1,
            SubDescription2: item.SubDescription2,
            SubDescription3: item.SubDescription3,
            TaxRate: item.TaxRate,
            SpellInstruction: item.SpellInstruction,
            OrderCooldownSeconds: item.OrderCooldownSeconds,
            PerPersonLimit: item.PerPersonLimit,
            CategoryPerPersonLimit: item.CategoryPerPersonLimit,
            choices: [], // 选择项数组
           
        }];
       
        const menuLink = submenuData.filter(submenu => submenu.MainItemCode === mainItemCode);
        let sequenceNumber = -1;
        let hasSelectChoiceTitle = false;
        // 遍历menuLink, 处理选择项
        menuLink.forEach(linkItem => {
            
            linkItem.sequence = sequenceNumber++;
            if (linkItem.SubCategory === 1 && linkItem.Description1 !== null) {
            // if (linkItem.Instruction === 1 && linkItem.SubCategory === 1 && linkItem.Description1 !== null) {
                
                const choiceItems = submenuData.filter(submenu => submenu.MainItemCode === linkItem.SubMenuCode && submenu.SoldOut === 0);
                 // 为 choiceItems 的每个元素添加序列号
                
             

                let title = linkItem.Description1;
                let NumberOfChoice = linkItem.NumberOfChoice;
                // let uniqueId = Date.now() + Math.random().toString(36).substr(2, 9);
                let uniqueId = `${mainItemCode}-${linkItem.SubMenuCode}`;

                //choiceItems里也加上相同的uniqueId
                choiceItems.forEach((choiceItem) => {
                    choiceItem.uniqueId = uniqueId;
                });
                

          
                submenu[0].choices.push({uniqueId, title , NumberOfChoice, items: choiceItems });
                choiceItems.forEach((choiceItem) => {
                    choiceItem.sequence = sequenceNumber++;
                    if (choiceItem.ChoiceItem === 0){

                       
                        handleSelectSubItem(uniqueId, choiceItem, choiceItem.SalesQty, title, false, NumberOfChoice, {uniqueId, title , NumberOfChoice, items: choiceItems });
                    }
                });
            } else if (linkItem.Instruction === 0) {
                hasSelectChoiceTitle = true;
                let title = ui('selectchoices');
                const existingGroup = submenu[0].choices.find(choice => choice.title === title);
                
                if (existingGroup) {
                    // 为 existingGroup 的每个新元素添加序列号
                    linkItem.sequence = sequenceNumber++;
                    existingGroup.items.push(linkItem);

                }else {
                    // 为新 group 的第一个元素添加序列号
                    linkItem.sequence = sequenceNumber++;
                    
                    submenu[0].choices.push({ title, NumberOfChoice: linkItem.NumberOfChoice, items: [linkItem], uniqueId: `${mainItemCode}-${linkItem.SubMenuCode}` });
                }
                // if (linkItem.ChoiceItem === 0){
                //     let uniqueId = `${linkItem.MainItemCode}-${linkItem.SubMenuCode}`;

                //     handleSelectSubItem(uniqueId, linkItem, linkItem.SalesQty, title, false, 0, {uniqueId, title, NumberOfChoice: linkItem.NumberOfChoice, items: [linkItem] });
                // }
                
            }
           
            
        });
 
        
        if (hasSelectChoiceTitle){
            const selectChoiceTitleItems = submenu[0].choices.find(choice => choice.title === ui('selectchoices'));
            selectChoiceTitleItems.items.forEach((choiceItem) => {
                if (choiceItem.ChoiceItem === 0){
                    let uniqueId = `${choiceItem.MainItemCode}-${choiceItem.SubMenuCode}`;
                    choiceItem.uniqueId = uniqueId;
                   
                    handleSelectSubItem(uniqueId, choiceItem, choiceItem.SalesQty, ui('selectchoices'), false, 0, {uniqueId, title: ui('selectchoices'), NumberOfChoice: 0, items: selectChoiceTitleItems.items });
                }
            });
        }

        
      
        
        setSelectedSubmenu(submenu);

       
        

      
        if(order){
            setMainItemQty(order[1].quantity, true)
            setSelectedmainItemPrice(order[1].price);
            // 恢复 multiple price 的选中位置
            setSelectedmainItemPosition(order[1].multiplePricePosition || 0);
            setSelectedMultipleButtonPosition(order[1].multiplePricePosition || 0);
            if (order[1].spellInstruction !== ''){
                setShowNoteBox(true);
                setNote(order[1].spellInstruction);
                
            }

            // console.log(order);
            // console.log(submenu[0].choices);
            // 恢复 multiple price 对应的描述子项
            const multiplePricePos = order[1].multiplePricePosition || 0;
            if (submenu[0].Multiple === 1 && multiplePricePos > 0) {
                let description;
                switch (multiplePricePos) {
                    case 1: description = submenu[0].SubDescription1; break;
                    case 2: description = submenu[0].SubDescription2; break;
                    case 3: description = submenu[0].SubDescription3; break;
                    default: description = submenu[0].SubDescription; break;
                }
                if (description) {
                    setSelectedSubmenuItems(prevItems => [...prevItems.filter(item => !item.isMultiple), {
                        itemCode: `multiple-${multiplePricePos}`,
                        itemDescription: description,
                        quantity: 1,
                        price: 0,
                        isMultiple: true,
                        taxrate: submenu[0].TaxRate,
                        sequence: -1,
                    }]);
                }
            }
            // 遍历order数组，除了主菜品以外的每个子菜品
            order.slice(2).forEach(subOrderItem => {
                // 跳过 isMultiple 项，已在上面恢复
                if (subOrderItem.isMultiple) return;
                // 对于每个子菜品，找到对应的choices组和子项
                const choiceGroup = submenu[0].choices.find(group =>
                    group.items.some(item => item.uniqueId === subOrderItem.choiceUniqueId));
         
                if (choiceGroup) {
                    const subMenuItem = choiceGroup.items.find(item => item.SubMenuCode === subOrderItem.itemCode && item.uniqueId === subOrderItem.choiceUniqueId);
                    if (subMenuItem) {
                        // 调用handleSelectSubItem来设置子项状态
                        handleSelectSubItem(choiceGroup.uniqueId, subMenuItem, subOrderItem.quantity, choiceGroup.title, choiceGroup.NumberOfChoice === 1, choiceGroup.NumberOfChoice, subMenuItem);
                        
                    }
                }
            });
      
        }
        else{
            setMainItemQty(1, true);
            setSelectedmainItemPrice(item.Price);
        }

    };
    const updateSelectedPriceByPosition = (index) => {
        setSelectedMultipleButtonPosition(index);
        let price;
        let position;
        let description;

        switch (index) {
            case 0:
                price = selectedSubmenu[0].Price;
                position = 0;
                description = selectedSubmenu[0].SubDescription;
                break;
            case 1:
                price = selectedSubmenu[0].Price1;
                position = 1;
                description = selectedSubmenu[0].SubDescription1;
                break;
            case 2:
                price = selectedSubmenu[0].Price2;
                position = 2;
                description = selectedSubmenu[0].SubDescription2;
                break;
            case 3:
                price = selectedSubmenu[0].Price3;
                position = 3;
                description = selectedSubmenu[0].SubDescription3;
                break;
            default:
                price = selectedSubmenu[0].Price;
                position = 0;
                description = selectedSubmenu[0].SubDescription;
        }

        setSelectedmainItemPrice(price);
        setSelectedmainItemPosition(position);

        // Remove any previous multiple selection from options
        setSelectedSubmenuItems(prevItems => 
            prevItems.filter(item => !item.isMultiple)
        );

        if (description) {
            // Add the new multiple selection as an option
            const multipleOption = {
                itemCode: `multiple-${position}`, // Unique identifier based on position
                itemDescription: description,
                quantity: 1,
                price: 0,
                isMultiple: true, // Flag to identify multiple selections
                taxrate: selectedSubmenu[0].TaxRate,
                sequence: -1, // Ensure it appears first or last based on preference
            };
            setSelectedSubmenuItems(prevItems => [...prevItems, multipleOption]);
        }
    };
        
    // const updateSelectedPriceByPosition = (index) => {
    //     setSelectedMultipleButtonPosition(index);
    //     switch (index) {
    //         case 0:
    //             setSelectedmainItemPrice(selectedSubmenu[0].Price);
    //             setSelectedmainItemPosition(0);

    //             break;
    //         case 1:
    //             setSelectedmainItemPrice(selectedSubmenu[0].Price1);
    //             setSelectedmainItemPosition(1);
    //             break;
    //         case 2:
    //             setSelectedmainItemPrice(selectedSubmenu[0].Price2);
    //             setSelectedmainItemPosition(2);
    //             break;
    //         case 3:
    //             setSelectedmainItemPrice(selectedSubmenu[0].Price3);
    //             setSelectedmainItemPosition(3);
    //             break;
    //         default:
    //             setSelectedmainItemPrice(selectedSubmenu[0].Price);
    //             setSelectedmainItemPosition(0);
    //     }
    // };
    
    const getCurrentQuantity = (SubMenuCode, uniqueId) => {

        // console.log(selectedSubmenuItems);
        const foundItem = selectedSubmenuItems.find(
          item => item.itemCode === SubMenuCode && item.choiceUniqueId === uniqueId
        );
   
        return foundItem ? foundItem.quantity : 0;
      };
      
  
    const [choiceSelectedSubItemNoList, setChoiceSelectedSubItemNoList, getChoiceSelectedSubItemNoList] = useGetState({}); // 用于存储每个选择项的已选子项数量
    const handleSelectSubItem = (uniqueId, item, newQuantity, title, isSingleChoice, NumberOfChoice, choice) => {
            console.log(uniqueId, item, newQuantity, title, isSingleChoice, NumberOfChoice, choice);
            if (NumberOfChoice === 1) {
                //remove all other choices
                setSelectedSubmenuItems(prevItems => {
                    let updatedItems;
                    updatedItems = prevItems.filter(subItem => subItem.choiceUniqueId !== uniqueId);
                    updatedItems = [
                        ...updatedItems,
                        {
                            itemCode: item.SubMenuCode,
                            itemDescription: item.Description1,
                            itemDescription1: item.Description2,
                            quantity: newQuantity,
                            price: item.SalesPrice,
                            instruction: item.Instruction,
                            choiceTitle: title,
                            choiceUniqueId: uniqueId,
                            taxrate: item.TaxRate,
                            sequence: item.sequence, // Include sequence
                        },
                    ];
                    updatedItems.sort((a, b) => a.sequence - b.sequence);
                    return updatedItems;
                });
            } else {

            if (((getChoiceSelectedSubItemNoList()[uniqueId] >= NumberOfChoice) && getChoiceSelectedSubItemNoList()[uniqueId]!==0 && NumberOfChoice!==0)||(NumberOfChoice===1 && newQuantity>1)) {
                setShowLimitMessage(true); // 显示消息
                
        
                // 3秒后隐藏消息
                setTimeout(() => {
                setShowLimitMessage(false);
                }, 2000);
            } else{
                // 确保数量不低于0
                newQuantity = Math.max(newQuantity, 0);

      
                const difference = newQuantity - getCurrentQuantity(item.SubMenuCode, uniqueId);
                // 累加已选子项数量，如果有新的uniqueId则创建新的属性
                setChoiceSelectedSubItemNoList(prevList => {
                    const updatedList = { ...prevList };
                    updatedList[uniqueId] = (updatedList[uniqueId] || 0) + difference;
                    return updatedList;
                });
            


                setSelectedSubmenuItems(prevItems => {
                    let updatedItems;
                
                  
                        const foundIndex = prevItems.findIndex(
                            subItem => subItem.itemCode === item.SubMenuCode && subItem.choiceUniqueId === uniqueId
                        );
                    
                        if (foundIndex >= 0) {
                            // Update the existing item's quantity
                            updatedItems = [...prevItems];
                            if (newQuantity > 0) {
                            updatedItems[foundIndex] = { ...updatedItems[foundIndex], quantity: newQuantity };
                            } else {
                            // Remove the item if quantity is zero
                            updatedItems.splice(foundIndex, 1);
                            }
                        } else if (newQuantity > 0) {
                            // Add new item
                            updatedItems = [
                            ...prevItems,
                            {
                                itemCode: item.SubMenuCode,
                                itemDescription: item.Description1,
                                itemDescription1: item.Description2,
                                quantity: newQuantity,
                                price: item.SalesPrice,
                                instruction: item.Instruction,
                                choiceTitle: title,
                                choiceUniqueId: uniqueId,
                                taxrate: item.TaxRate,
                                sequence: item.sequence, // Include sequence
                            },
                            ];
                        } else {
                            updatedItems = prevItems;
                        }
                    // }
                
                    // Sort the updated items by sequence
                    updatedItems.sort((a, b) => a.sequence - b.sequence);
                
                    return updatedItems;
                });
                };
        }
        console.log(selectedSubmenuItems);
};


    useEffect(() => {
        
        // 计算总价格
        let total = 0;
        if (selectedSubmenu && selectedmainItemPrice) {
            selectedSubmenuItems.forEach(item => {
                total += item.price * item.quantity*selectedmainItemQty;
            });
            
            total += (selectedmainItemPrice || selectedSubmenu[0].Price) * selectedmainItemQty;
            
            //最后两位数
            total = Math.round(total * 100) / 100;
            setSelectedTotalPrice(total);

        }
        
    }, [selectedSubmenuItems, selectedmainItemPrice, selectedmainItemQty]);
    
    const handleAddToCart = () => {
        if (selectedSubmenu?.[0] && isCoolingDown(selectedSubmenu[0].MainItemCode)) {
            showCooldownMessage({
                ItemCode: selectedSubmenu[0].MainItemCode,
                Description1: selectedSubmenu[0].Description,
                Description2: selectedSubmenu[0].Description1,
            });
            return;
        }
        const excludedRestoreQuantity = restoreOrder && String(restoreOrder[1]?.mainItemCode) === String(selectedSubmenu?.[0]?.MainItemCode)
            ? Number(restoreOrder[1]?.quantity) || 0
            : 0;
        if (selectedSubmenu?.[0] && !canAddMenuItemQuantity(selectedSubmenu[0], selectedmainItemQty, excludedRestoreQuantity)) {
            return;
        }
       
        if (restoreOrder){
            for (let i = 0; i < restoreOrder[1].quantity; i++) {
                // 从购物车中删除订单
                removeOrderFromCart(restoreOrder);
            }
                setRestoreOrder(null);
                toggleCartPopup();
        }
    
        //遍历selectedSubmenu[0].choices里，如果有NumberOfChoice>=1的，检查selectedSubmenuItems里ChoiceTitle，如果数量没有达到NumberOfChoice，弹出提示
        for (const choice of selectedSubmenu[0].choices) {
            if (choice.NumberOfChoice >= 1) {
                const choiceItems = selectedSubmenuItems.filter(item => item.choiceTitle === choice.title);
                let totalQuantity = 0;
                for (let i = 0; i < choiceItems.length; i++) {
                    totalQuantity += choiceItems[i].quantity;
                }

                if (totalQuantity < choice.NumberOfChoice ) {
                    setMustBeSelectedMessage(choice.title); // 显示消息
                    // 3秒后隐藏消息
                    setTimeout(() => {
                        setMustBeSelectedMessage(null);
                        const choiceElementId = `choice-${choice.title.replace(/\s/g, '-')}`;
                        const choiceElement = document.getElementById(choiceElementId);
                        if (choiceElement) {
                            choiceElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    }, 2000);
                    return; // 这里退出整个 handleAddToCart 函数
                }
            }
        }
        
        
        // 添加主项目到订单
        const mainItem = {
            mainItemCode: selectedSubmenu[0].MainItemCode,
            mainItemDescription: selectedSubmenu[0].Description === "" ? selectedSubmenu[0].Description1 : selectedSubmenu[0].Description,


            mainItemDescription1: selectedSubmenu[0].Description1 === "" ? selectedSubmenu[0].Description : selectedSubmenu[0].Description1,
            quantity: selectedmainItemQty, 
            price: selectedmainItemPrice || selectedSubmenu[0].Price,
            multiplePricePosition: selectedmainItemPosition,
            taxrate: selectedSubmenu[0].TaxRate,
            orderCooldownSeconds: Number(selectedSubmenu[0].OrderCooldownSeconds) || 0,
            perPersonLimit: Number(selectedSubmenu[0].PerPersonLimit) || 0,
            categoryCode: selectedSubmenu[0].CategoryCode,
            categoryPerPersonLimit: Number(selectedSubmenu[0].CategoryPerPersonLimit) || 0,
            category: selectedSubmenu[0].Category,
            menuGroup: selectedSubmenu[0].MenuGroup,
            spellInstruction: note


        };
        
    
        // 整合主项目和所有已选择的子项目
        const completeOrder = [mainItem, ...selectedSubmenuItems];
    
        // 处理完整的订单

        handleAddToContextCart(completeOrder);
        if (optionsProductRef.current && selectedSubmenu && selectedSubmenu[0] && storeId) {
            const productRect = optionsProductRef.current.getBoundingClientRect();
            animateFlyToCart({
                startRect: {
                    left: productRect.left,
                    top: productRect.top,
                    width: productRect.width,
                    height: productRect.height,
                },
                imageUrl: menuItemImageUrl(selectedSubmenu[0].MainItemCode),
                motion: 'flat'
            });
        }
        handleClosePopup();
        setNote('');
        setShowNoteBox(false);
        


        
    };
    
    const setMainItemQty = (qty, skipLimit = false) => {
        if (!skipLimit && qty > selectedmainItemQty && selectedSubmenu?.[0]) {
            const excludedRestoreQuantity = restoreOrder && String(restoreOrder[1]?.mainItemCode) === String(selectedSubmenu[0].MainItemCode)
                ? Number(restoreOrder[1]?.quantity) || 0
                : 0;
            if (!canAddMenuItemQuantity(selectedSubmenu[0], qty, excludedRestoreQuantity)) {
                return;
            }
        }
        setSelectedmainItemQty(qty);
    };



    //导航到/QROrder/:restaurantUrl/order/:tableNo
    async function checkOut() {

        if (!serviceAvailable){
            console.log('service not available');
            navigate('/unavailable');
            return;
        }
        let latestGuestState = null;
        try {
            latestGuestState = await refreshDineInGuestState();
        } catch (error) {
            console.error('Error refreshing dine-in guest count:', error);
        }
        const hasLatestGuestCount = latestGuestState
            ? latestGuestState.hasServerGuestCount && Number(latestGuestState.guestCount) > 0
            : serverHasDineInGuestCount && Number(dineInGuestCount) > 0;
        if (needsGuestCount(latestGuestState) && !hasLatestGuestCount) {
            const nextCount = 2;
            setSelectedGuestCount(nextCount);
            setCustomGuestCount(nextCount > 5 ? String(nextCount) : '');
            setCustomGuestCountMode(nextCount > 5);
            setShowPromotionAfterGuestCount(false);
            setShowGuestCountPopup(true);
            notification.warning({
                message: ui('guestCountRequired'),
                ...warningPlacement,
            });
            return;
        }
        if (tableNo === 'take_away' || tableNo === 'Take-away') {
            setServiceMode('Take-away');


            setTableNumber('Take-away')
        }else{
            const isValidTableNo = /^[A-Za-z\d]{1,10}$/.test(tableNo);

            if (isValidTableNo ) {
                setServiceMode('Dine-in');
                setTableNumber(tableNo); // 假设setTableNumber是一个用于更新状态的函数
            } else {
                navigate('/unavailable');
                return;
            }
        }

        if (MaxItemInCart < totalQuantity && MaxItemInCart !== 0){
            setShowMaxLimitMessage(true); // 显示消息
            // 3秒后隐藏消息
            setTimeout(() => {
                setShowMaxLimitMessage(false); // 显示消息
            }, 1500);
            return;
        }



        //check available time

        if (payFirst === 0 && useLocation1 === 1 && noAuth === 0 ){

            getUserLocationAndCompare(storeLocationRange);
        }


        else {
            setLocationValid(true);
            navigate(`/qr_order/${restaurantUrl}/order`);
        }


    }


    function getOrderAmount(order) {
        // 主菜品
        const mainItem = order[1]; // 第二个元素是主菜品
        let orderAmount = mainItem.price * mainItem.quantity;
    
        // 子菜品
        const subItems = order.slice(2); // 从第三个元素开始是子菜品
        subItems.forEach(subItem => {
            orderAmount += subItem.price * subItem.quantity * mainItem.quantity;
        });
    
        return orderAmount.toFixed(2); // 格式化为两位小数
    }
    const animateCartIcon = () => {
        if (!cartIconRef.current || !cartIconRef.current.animate) {
            return;
        }

        cartIconRef.current.animate(
            [
                { transform: 'scale(1)', filter: 'drop-shadow(0 0 0 rgba(245, 132, 10, 0))' },
                { transform: 'scale(1.08)', filter: 'drop-shadow(0 8px 12px rgba(245, 132, 10, 0.22))' },
                { transform: 'scale(0.97)', filter: 'drop-shadow(0 4px 8px rgba(245, 132, 10, 0.14))' },
                { transform: 'scale(1)', filter: 'drop-shadow(0 0 0 rgba(245, 132, 10, 0))' }
            ],
            {
                duration: 620,
                easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            }
        );
    };

    const animateFlyToCart = ({ startRect, imageUrl, motion = 'default' }) => {
        if (!startRect || !cartIconRef.current) {
            return;
        }

        const cartRect = cartIconRef.current.getBoundingClientRect();
        const ghostSize = Math.max(42, Math.min(64, startRect.width || 56));
        const startLeft = startRect.left + (startRect.width / 2) - (ghostSize / 2);
        const startTop = startRect.top + (startRect.height / 2) - (ghostSize / 2);
        const endLeft = cartRect.left + (cartRect.width / 2) - (ghostSize / 2);
        const endTop = cartRect.top + (cartRect.height / 2) - (ghostSize / 2);
        const deltaX = endLeft - startLeft;
        const deltaY = endTop - startTop;
        const isFlatMotion = motion === 'flat';
        const peakY = isFlatMotion ? Math.min(-3, deltaY * 0.01 - 1) : Math.min(-12, deltaY * 0.06 - 8);
        const midX = deltaX * 0.46;

        const flyingItem = document.createElement('div');
        flyingItem.setAttribute(
            'style',
            [
                'position:fixed',
                `left:${startLeft}px`,
                `top:${startTop}px`,
                `width:${ghostSize}px`,
                `height:${ghostSize}px`,
                'border-radius:16px',
                'overflow:hidden',
                'pointer-events:none',
                'z-index:10010',
                'background:linear-gradient(135deg,#fff7ed 0%,#fde7cf 100%)',
                'box-shadow:0 14px 28px rgba(0,0,0,0.16), 0 4px 10px rgba(245,132,10,0.18)',
                'border:1px solid rgba(255,255,255,0.8)',
                'backdrop-filter:blur(8px)',
                'transform-origin:center center'
            ].join(';')
        );

        const img = document.createElement('img');
        img.src = imageUrl || '/img/food-grey.jpg';
        img.alt = '';
        img.setAttribute(
            'style',
            'width:100%;height:100%;display:block;object-fit:cover;'
        );
        img.onerror = () => {
            img.onerror = null;
            img.src = '/img/food-grey.jpg';
        };

        document.body.appendChild(flyingItem);
        flyingItem.appendChild(img);

        if (flyingItem.animate) {
            const animation = flyingItem.animate(
                [
                    { transform: 'translate3d(0, 0, 0) scale(1) rotate(0deg)', opacity: 0.98, offset: 0 },
                    { transform: `translate3d(${midX}px, ${peakY}px, 0) scale(${isFlatMotion ? 0.97 : 0.98}) rotate(${isFlatMotion ? -0.2 : -1}deg)`, opacity: 1, offset: 0.42 },
                    { transform: `translate3d(${deltaX * 0.84}px, ${deltaY * 0.86}px, 0) scale(${isFlatMotion ? 0.75 : 0.72}) rotate(${isFlatMotion ? 0.2 : 1}deg)`, opacity: 0.9, offset: 0.84 },
                    { transform: `translate3d(${deltaX}px, ${deltaY}px, 0) scale(0.22) rotate(0deg)`, opacity: 0.08, offset: 1 }
                ],
                {
                    duration: 1380,
                    easing: 'cubic-bezier(0.2, 0.78, 0.22, 1)',
                    fill: 'forwards'
                }
            );

            animation.onfinish = () => {
                if (document.body.contains(flyingItem)) {
                    document.body.removeChild(flyingItem);
                }
                animateCartIcon();
            };
        } else {
            flyingItem.style.transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(0.18)`;
            flyingItem.style.opacity = '0';
            setTimeout(() => {
                if (document.body.contains(flyingItem)) {
                    document.body.removeChild(flyingItem);
                }
                animateCartIcon();
            }, 1380);
        }
    };

    const addToCart = (item, event) => {
        const buttonRect = event.currentTarget.getBoundingClientRect();
        const startRect = {
            left: buttonRect.left - 8,
            top: buttonRect.top - 8,
            width: buttonRect.width + 16,
            height: buttonRect.height + 16,
        };

        animateFlyToCart({
            startRect,
            imageUrl: menuItemImageUrl(item.ItemCode)
        });
    };

    const handlePartnerPopupCloseStart = ({ rect, imageUrl }) => {
        animateFlyToCart({
            startRect: rect,
            imageUrl
        });
    };

    
    const ClickOrderReview = () => {
        navigate(`/qr_order/${restaurantUrl}/${tableNo}/orderReview`, { state: {} });
    };


    return (

    <div>
        <PartnerAddPopup
            key={partnerFirstAdd ? partnerFirstAdd.ts : 'idle'}
            visible={enableSharedCart && !!partnerFirstAdd}
            title={ui('partner_ordered_title')}
            dishName={getPartnerDishName(partnerFirstAdd)}
            imageUrl={partnerFirstAdd && storeId ? menuItemImageUrl(partnerFirstAdd.mainItem.mainItemCode) : null}
            typewriterText={getPartnerDishName(partnerFirstAdd)}
            onCloseStart={handlePartnerPopupCloseStart}
            onClose={clearPartnerFirstAdd}
        />
        {showGuestCountPopup && (
            <div className="guest-count-overlay">
                <div className="guest-count-sheet">
                    <div className="guest-count-hero-icon" aria-hidden="true">
                        <img src="/img/guest-count-people-icon.png" alt="" />
                    </div>
                    <h2>{ui('guestCountTitle')}</h2>
                    <p>{ui('guestCountSubtitle')}</p>
                    <div className="guest-count-grid">
                        {guestCountOptions.map((count) => {
                            const selected = !customGuestCountMode && selectedGuestCount === count;
                            return (
                                <button
                                    type="button"
                                    key={count}
                                    className={`guest-count-option ${selected ? 'selected' : ''}`}
                                    onClick={() => {
                                        setSelectedGuestCount(count);
                                        setCustomGuestCountMode(false);
                                        setCustomGuestCount('');
                                    }}
                                >
                                    {selected && <span className="guest-count-check">✓</span>}
                                    <img
                                        className="guest-count-card-icon"
                                        src={`/img/guest-count-people-${count}.png`}
                                        alt=""
                                    />
                                    <strong>{guestCountLabel(count)}</strong>
                                </button>
                            );
                        })}
                        <div
                            className={`guest-count-option guest-count-custom ${isCustomGuestCountSelected ? 'selected' : ''}`}
                            onClick={() => {
                                setCustomGuestCountMode(true);
                                setSelectedGuestCount(null);
                            }}
                        >
                            {isCustomGuestCountSelected && <span className="guest-count-check">✓</span>}
                            <span className="guest-count-custom-icon">6+</span>
                            <input
                                className="guest-count-custom-input"
                                type="number"
                                min="6"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={customGuestCount}
                                placeholder={ui('guestCountPlus')}
                                onClick={(e) => e.stopPropagation()}
                                onFocus={() => {
                                    setCustomGuestCountMode(true);
                                    setSelectedGuestCount(null);
                                }}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, '').slice(0, 3);
                                    setCustomGuestCount(value);
                                    setCustomGuestCountMode(true);
                                    const parsed = Number.parseInt(value, 10);
                                    if (parsed >= 6) {
                                        setSelectedGuestCount(parsed);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <button
                        type="button"
                        className="guest-count-confirm"
                        onClick={() => saveGuestCount(getGuestCountToSave())}
                    >
                        {ui('guestCountConfirm')}
                    </button>
                </div>
            </div>
        )}
        {showMenuGroupPopup && (
            <div className="menu-group-selection-overlay">
                <div className="menu-group-selection-panel">
                    <h2 className="menu-group-selection-title">{ui('menuGroupTitle')}</h2>
                    <div className="menu-group-selection-grid">
                        {menuGroupOptions.map((group) => {
                            const price = Number(group.MenuGroupPrice) || 0;
                            const displayName = group.DisplayName || group.Description;
                            const isSelected = pendingMenuGroupCode === group.Code;
                            return (
                                <button
                                    type="button"
                                    key={group.Code}
                                    className={`menu-group-selection-card ${Number(group.Popular) === 1 ? 'popular' : ''} ${isSelected ? 'selected' : ''}`}
                                    onClick={() => setPendingMenuGroupCode(group.Code)}
                                >
                                    {Number(group.Popular) === 1 && (
                                        <div className="menu-group-popular-ribbon">{ui('menuGroupPopular')}</div>
                                    )}
                                    <img
                                        className="menu-group-card-image"
                                        src={menuGroupImageUrl(group.Code)}
                                        alt=""
                                        loading="lazy"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = '/img/blank.jpeg';
                                        }}
                                    />
                                    <div className="menu-group-card-content">
                                        <strong>{displayName}</strong>
                                    {price > 0 && (
                                        <div className="menu-group-card-price">
                                            <small>$</small>
                                            <span>{price.toFixed(2).replace(/\.00$/, '')}</span>
                                            <em>{ui('menuGroupPerPerson')}</em>
                                        </div>
                                    )}
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                    <div className="menu-group-selection-footer">
                        <button
                            type="button"
                            className="menu-group-selection-confirm"
                            onClick={confirmMenuGroupSelect}
                        >
                            {ui('menuGroupConfirm')}
                        </button>
                    </div>
                </div>
            </div>
        )}
        <div>
        {showLandingPage && (
    <div 
        className="landing-page" 
        onClick={async () => {
            setShowLandingPage(false);
            setShowPromotionAfterGuestCount(promotionEnabled || (menuGroupSelectionEnabled && menuGroupOptions.length > 0));
            let latestGuestState = null;
            try {
                latestGuestState = await refreshDineInGuestState();
            } catch (error) {
                console.error('Error refreshing dine-in guest count:', error);
            }
            const guestPopupOpened = openGuestCountPopupIfNeeded(latestGuestState);
            if (!guestPopupOpened) {
                continueAfterStartupGate();
            }
        }}
        style={{
            position: 'fixed',
            marginTop:"56px",
            left: 0,
            width: '100%',
            height: '100%',
            // backgroundColor: `rgba(${hexToRgb(loadingPageColor)}, ${loadingPagePercentage})`,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000, // Ensure it overlays other content
            cursor: 'pointer'
        }}
    >
        <img 
            src={`${process.env.REACT_APP_SERVER_URL}/storeLandingImage/${storeId}`} 
            alt="Landing" 
            style={{ 
                width: '100%',
            height: '100%',
                maxWidth: '100%', 
                maxHeight: '100%',
                objectFit: 'cover'
            }} 
            onError={(e) => { 
                e.target.onerror = null; 
                e.target.src = '/img/default_landing_image.jpg'; // Fallback image
            }}
        />
    </div>
)}

                {showMaxLimitMessage&& (
                    <div className="limit-message-overlay1">
                        {ui('maxLimitDetail', { max: MaxItemInCart })}
                    </div>
                )}

              {showLimitMessage && (
                <div className="limit-message-overlay">
                    {ui('maxLimit')}
                </div>
                )}
                {mustBeSelectedMessage && (
                <div className="limit-message-overlay">
                
                   <div><b style={{fontSize:'18px'}}>{mustBeSelectedMessage}</b></div>
                   <div>{ui('mustBeSelected')}</div>
          
                </div>
                )}
            <div className={`header ${iconloading && storeConfigTag && imagesLoaded? 'hide' : ''}`}>

                <div className="box">
                    <div className="left">
                             <div className="item" >
                                {/* <img src="/img/icon1.svg" id="btn3" onClick={toggleSidePopup}/> */}
                            </div>
                            <div style={{paddingLeft:'24px'}}>
                           {storeName}</div>
                    </div>
                    <div className="right">
                        <div className="item">

                            <a href={`/qr_order/${restaurantUrl}`}>
                                {/* <img src="/img/icon6.svg"/> */}
                            </a>
                        </div>
                        
                        {secondLanguage&&<div className="item" id="btn">
                            {/* <img src="/img/icon7.svg" onClick={toggleLanguagepopup}/> */}
                        </div>}
                        <div className="yyqh" style={{ height: languagepopup ? '108px' : '0px' }}>


                            <div className="item2"   onClick={() => toggleLanguage(0)}>{getLanguageLocalName(firstLanguage)}</div>
                            <div className="item2"  onClick={() => toggleLanguage(1)}>{getLanguageLocalName(secondLanguage)}</div>
                         
                        </div>
                    </div>
                </div>
            </div>
          
            <div className={`kong ${imagesLoaded && storeConfigTag && imagesLoaded ? 'hide' : ''}`}>
                <div className="page_t1">
                    <div className="box">
                        <ul>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    </div>
                </div>

                <div className="sp_list2">
                    <ul>
                        <li>
                            <a href="#">
                                <div className="img">

                                </div>
                                <div className="info">
                                    <div className="r1"></div>
                                    <div className="r2"> </div>
                                    <div className="r3"></div>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="img">

                                </div>
                                <div className="info">
                                    <div className="r1"></div>
                                    <div className="r2"> </div>
                                    <div className="r3"></div>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="img">

                                </div>
                                <div className="info">
                                    <div className="r1"></div>
                                    <div className="r2"> </div>
                                    <div className="r3"></div>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="img">

                                </div>
                                <div className="info">
                                    <div className="r1"></div>
                                    <div className="r2"> </div>
                                    <div className="r3"></div>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <div className="img">

                                </div>
                                <div className="info">
                                    <div className="r1"></div>
                                    <div className="r2"> </div>
                                    <div className="r3"></div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            {iconloading && storeConfigTag && imagesLoaded && 
            <div>
                <div className='header'>

                <div className="box">
                    <div className="left">
                            <div className="item">
                                <img src="/img/icon1.svg" id="btn3" onClick={toggleSidePopup}/>
                            </div>
                            <div>
                        {storeName}</div>
                    </div>
                    <div className="right">
                        {/* <div className="item">

                            <a href={`/qr_order/${restaurantUrl}`}>
                                <img src="/img/icon6.svg"/>
                            </a>
                        </div> */}
                        
                        {gethasUnpaidOrder() && <div className="item" id="btn">
                            <img src="/img/orderApprove.svg" className=' icon-google-white' onClick={ClickOrderReview}/>
                            </div>} 
                          
                        {secondLanguage&&multipleLanguage===1&&<div className="item" id="btn">
                            <img src="/img/icon7.svg" onClick={toggleLanguagepopup}/>
                        </div>}
                        <div className="yyqh" style={{ height: languagepopup ? '108px' : '0px' }}>


                            <div className="item2"   onClick={() => toggleLanguage(0)}>{getLanguageLocalName(firstLanguage)}</div>
                            <div className="item2"  onClick={() => toggleLanguage(1)}>{getLanguageLocalName(secondLanguage)}</div>
                            {/* <div className="item2">한국어</div>
                            <div className="item2">日本語日本語日本語日本語日本語</div> */}
                        </div>
                    </div>
                </div>
                </div>
                <div style={{height:'48px'}}></div>

                <div className='page_t1'>
                <div className="box">
                    <ul>
                        {categoryList.map(cat => (
                            <li 
                                key={cat} 
                                id={`page_t1-category-${cat}`}
                                className={cat === selectedCategory ? 'active' : ''} 
                                onClick={() => handleCategoryClick(cat)}
                            >
                                {cat}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="icon">
                    <img src="/img/icon8.svg" id="btn2" onClick={toggleFullCategorypopup}/>
                    <div className="icon_popup" style={{height: fullCategorypopup ? '297px' : '0px', 
                                }}>
                        <div className="head">
                            <span>{ui('fullmenu')}</span>
                            <img src="/img/icon3.svg" id="btn3" onClick={toggleFullCategorypopup}/>
                        </div>
                        <div className="body">

                            {categoryList.map(cat => (
                                <div 
                                    key={cat} 
                                    id={`icon_popup-category-${cat}`} 
                                    className={`cell_item ${cat === selectedCategory ? 'active' : ''}`} 
                                    onClick={() => handleFullCategoryClick(cat)}
                                >
                                    {cat}
                                </div>
                            ))}

                            
                        </div>
                    </div>
                </div>
                </div>
                <div className={`sp_list2 ${!imagesLoaded ? 'hide' : ''}`}>
                    
                        {Object.entries(mainCategories).map(([category, items], index) => (
                            <React.Fragment key={category}>
                                {/* 只在第一个项目前显示分类标题 */}
                                <h2  id={category} style={{ fontSize: '16px', fontWeight: 'bold' }}>{category}</h2>
                                <ul>
                                {items.map(item => {
                                const cooldownSeconds = getCooldownSeconds(item);
                                const cooldownRemaining = getCooldownRemaining(item.ItemCode);
                                const itemCoolingDown = cooldownRemaining > 0;
                                const hasCooldown = cooldownSeconds > 0;
                                const itemLimitState = getPerPersonLimitState(item, 1);
                                const itemLimitBadgeState = getPerPersonLimitBadgeState(item);
                                const itemLimitReached = Boolean(itemLimitState.overLimit);
                                const showItemLimitBadge = shouldShowPerPersonLimitBadge(itemLimitBadgeState);
                                return item.Enable === 1 && (
                                    <li key={item.ItemId} className={`${hasCooldown ? 'has-cooldown' : ''} ${itemCoolingDown ? 'cooldown-active' : ''} ${itemLimitReached ? 'per-person-limit-active' : ''}`}>
                                        {/* <a href="#"> */}
                                        <a>
                                            <div className="img">
                                                {/* <img crossOrigin="anonymous" 
                                                    src={`${process.env.REACT_APP_SERVER_URL}/images/${storeId}/menuItems/${item.ItemCode}`}
                                                    onLoad={handleImageLoad} 
                                                    onError={(e) => { e.target.onerror = null; e.target.src = '/img/blank.jpeg';}}/> */}
                                                    <div className="sold-out-container">
                                                        <img crossOrigin="anonymous" 
                                                        src={menuItemImageUrl(item.ItemCode)}
                                                        loading="lazy"
                                                        onLoad={handleImageLoad} 
                                                        onError={(e) => { e.target.onerror = null; e.target.src = '/img/blank.jpeg';}}/>
                                                        {item.SoldOut === 1 && (
                                                            <div className="sold-out-text">Sold Out</div>
                                                        )}
                                                        {itemCoolingDown && (
                                                            <div className="cooldown-image-overlay">
                                                                <span>{cooldownRemaining}s</span>
                                                            </div>
                                                        )}
                                                        {itemLimitReached && !itemCoolingDown && (
                                                            <div className="per-person-limit-image-overlay">
                                                                <span>{ui('itemLimitShort')}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                            </div>
                                            <div className="info">
                                            
                                                
                                            <div className="r1">
                                               
                                            {item.Description1 ? item.Description1 : item.Description2}
                                            
                                            </div>
                                            {item.Notes !== "" ? (
                                                <span className="r3">
                                                    {item.Notes}
                                                </span>
                                            ) : (
                                                item.TagDescription && (
                                                    <span className="r3">
                                                        {item.TagDescription}
                                                    </span>
                                                )
                                            )}
                                            {showItemLimitBadge && (
                                                <div className="per-person-limit-badge">
                                                    <span className="per-person-limit-dot"></span>
                                                    <span>{getPerPersonLimitBadgeText(itemLimitBadgeState)}</span>
                                                </div>
                                            )}

                                            
                                            
                                            {/* <div className="r3">{item.Notes}</div> */}
                                        
                                            <div className="r4">
                                                <div className="left">
                                                {showPriceInCustomerMenu ? (
                                                    <>
                                                    {((hasSubmenu(item.ItemCode) || item.Multiple === 1) && item.SoldOut !==1)&&
                                                    <span className='r4-from'>from
                                                        </span>}
                                                        <small>$</small>
                                                        <span>{item.Price}</span>
                                                    </>
                                                ) : (
                                                    <span>&nbsp;</span>
                                                )}
                                                </div>


                                                <div className="right">
                                                    {((hasSubmenu(item.ItemCode) || item.Multiple === 1) && item.SoldOut !==1) ? (
                                                        <button 
                                                            type="button" 
                                                            className={`btn btn-warning btn-sm ${itemCoolingDown ? 'cooldown-button' : ''} ${itemLimitReached ? 'per-person-limit-button' : ''}`} 
                                                            disabled={itemCoolingDown}
                                                            onClick={() => handleSelectOptionsClick(item.ItemCode,category)}
                                                        >
                                                            {itemCoolingDown ? `${cooldownRemaining}s` : (itemLimitReached ? ui('itemLimitShort') : ui('options'))}
                                                        </button>

                                                    ) : (
                                                    
                                                        <div className="Stepper">
                                                            {getMainItemQuantity(item.ItemCode) > 0 && (
                                                                <button onClick={(e) => {
                                                                    e.preventDefault(); // 阻止默认行为
                                                                    decreaseItemCount(item); // 执行增加数量的逻辑
                                                                }}>
                                                                    <img src="/img/icon11.svg"/>
                                                                </button>
                                                                // <img
                                                                //     src="/img/minus.svg"
                                                                //     alt="Minus"
                                                                //     onClick={(e) => {
                                                                //         e.preventDefault();
                                                                //         decreaseItemCount(item);
                                                                //     }}
                                                                //     style={{width: '33px', // 设置宽度
                                                                //     height: '33px', }} 
                                                                // />

                                                            )}
                                                            <span>{getMainItemQuantity(item.ItemCode)> 0 ? getMainItemQuantity(item.ItemCode) : null}</span>

                                                            {item.SoldOut!== 1&&(<button className={`jia ${itemCoolingDown ? 'cooldown-button' : ''} ${itemLimitReached ? 'per-person-limit-button' : ''}`} disabled={itemCoolingDown} onClick={(e) => {
                                                                    e.preventDefault(); // 阻止默认行为
                                                                    if (showCooldownMessage(item)) return;
                                                                    increaseItemCount(item); // 执行增加数量的逻辑
                                                                    addToCart(item, e); // 调用飞入购物车的动画
                                                                }}>
                                                                <img src="/img/icon10.svg" alt="Plus" />
                                                            </button>)}
                                                            {/* <img
                                                                    src="/img/plus.svg"
                                                                    alt="Minus"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        increaseItemCount(item);
                                                                    }}
                                                                    style={{width: '28px', // 设置宽度
                                                                    height: '28px', }} 
                                                                /> */}

                                                        </div>
                                                        
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        </a>
                                    </li>
                                )
                                })}
                                </ul>
                                {/* 在类别间显示分隔符
                                {index !== Object.entries(mainCategories).length - 1 && <hr />} */}
                            </React.Fragment>
                        ))}
                    
                </div>


                {selectedSubmenu &&
                <div className={`popup gg_popup ${submenupopup ? 'show' : ''}`}>
                    <div className="bg"></div>
                    <div className="popup_box">
                        <div className="popup_head">
                            <span>{ui('selectoptions')}</span>
                            <img src="/img/icon3.svg" onClick={() => handleClosePopup()} alt="Close" />
                        </div>
                        <div ref={optionsProductRef} className="sp_list2 v3">
                            <ul>
                                <li>
                                    <a href="#">
                                        <div className="img">
                                            <img crossOrigin="anonymous" src={menuItemImageUrl(selectedSubmenu[0].MainItemCode)}  onError={(e) => { e.target.onerror = null; e.target.src = '/img/blank.jpeg';}}/>
                                        </div>
                                        <div className="info">
                                            <div className="r1">{selectedSubmenu[0].Description}</div>
                                            {/* <div className="r2">
                                                <img src="/img/chili.png"/>
                                                <img src="/img/icon9.svg"/>
                                                <img src="/img/icon9.svg"/>
                                            </div> */}

                              
                                            {selectedSubmenu[0].TagDescription&&<span className="r3">
                                                {selectedSubmenu[0].TagDescription }
                                            </span >}

                                            <div className="r4">
                                                <div className="left">
                                                    {showPriceInCustomerMenu ? (
                                                        <>
                                                            <small>$</small>
                                                            <span>{getSelectedTotalPrice() != null ? getSelectedTotalPrice() : selectedSubmenu[0].Price}</span>
                                                        </>
                                                    ) : (
                                                        <span>&nbsp;</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="popup_body">


                            {selectedSubmenu[0].Multiple===1 &&
                            <div>
                                {/* <div className="gg_title">Select Options</div> */}
                                <div className="gg_t1">
                                    {selectedSubmenu[0].SubDescription && (
                                        <button type="button"
                                            className={selectedMutipleButtonPosition === 0 ? 'btn btn-outline-warning' : 'btn btn-light'}
                                            onClick={() => updateSelectedPriceByPosition(0)}>
                                            <span>{selectedSubmenu[0].SubDescription}</span>
                                            <span className="text2">{showPriceInCustomerMenu ? ` $${selectedSubmenu[0].Price}` : '\u00A0'}</span>
                                        </button>
                                    )}
                                    {selectedSubmenu[0].SubDescription1 && (
                                        <button type="button"
                                            className={selectedMutipleButtonPosition === 1 ? 'btn btn-outline-warning' : 'btn btn-light'}
                                            onClick={() => updateSelectedPriceByPosition(1)}>
                                            {selectedSubmenu[0].SubDescription1}
                                            <span className="text2">{showPriceInCustomerMenu ? ` $${selectedSubmenu[0].Price1}` : '\u00A0'}</span>
                                        </button>
                                    )}
                                    {selectedSubmenu[0].SubDescription2 && (
                                        <button type="button"
                                            className={selectedMutipleButtonPosition === 2 ? 'btn btn-outline-warning' : 'btn btn-light'}
                                            onClick={() => updateSelectedPriceByPosition(2)}>
                                            
                                            {selectedSubmenu[0].SubDescription2}
                                            <span className="text2">{showPriceInCustomerMenu ? ` $${selectedSubmenu[0].Price2}` : '\u00A0'}</span>
                                        </button>
                                    )}
                                    {selectedSubmenu[0].SubDescription3 && (
                                        <button type="button"
                                            className={selectedMutipleButtonPosition === 3 ? 'btn btn-outline-warning' : 'btn btn-light'}
                                            onClick={() => updateSelectedPriceByPosition(3)}>
                                            
                                            {selectedSubmenu[0].SubDescription3}
                                            <span className="text2">{showPriceInCustomerMenu ? ` $${selectedSubmenu[0].Price3}` : '\u00A0'}</span>
                                        </button>
                                    )}
                                </div>


                            </div>}
                            {selectedSubmenu.length > 0 && selectedSubmenu[0].choices.map((choice) => (
                                <div key={choice.title}>
                                    <div className="gg_title"  id={`choice-${choice.title.replace(/\s/g, '-')}`}>{choice.title}</div>
                                    {choice.NumberOfChoice === 1 ? (
                                        <div className="gg_t1">
                                            {choice.items.map((item) => (
                                                <button 
                                                    key={item.SubMenuCode} 
                                                    type="button" 
                                                    className={`btn ${selectedSubmenuItems.some(subItem => subItem.itemCode === item.SubMenuCode &&  subItem.choiceUniqueId === choice.uniqueId) ? 'btn-outline-warning' : 'btn-light'}`}
                                                    onClick={() => handleSelectSubItem(choice.uniqueId, item, 1, choice.title, choice.NumberOfChoice === 1, choice.NumberOfChoice, choice)}
                                                >
                                                    {item.Description1}
                                                    <span className="text2">{showPriceInCustomerMenu && item.SalesPrice !== 0 ? ` +$${item.SalesPrice}` : '\u00A0'}</span>

                                                </button>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="gg_t2">
                                            {choice.items.map((item) => {
                                              
                                                
                                              
                                                const currentQuantity = getCurrentQuantity(item.SubMenuCode, choice.uniqueId);
                                                
                                                const isChoiceItem = item.ChoiceItem === 1; 
                                                
                                                return (
                                                <div key={item.SubMenuCode + choice.uniqueId} className={ currentQuantity > 0 ? 'item v2' : 'item'}>
                                                    <div className="left">
                                                        <p className="text1">{item.Description1}</p>
                                                        <p className="text2">{showPriceInCustomerMenu ? `+$${item.SalesPrice}` : '\u00A0'}</p>
                                                    </div>
                                                    <div className="right">
                                                        <div className="Stepper">
                                                        {currentQuantity > 0  && isChoiceItem && (
                                                            <>
                                                                <button onClick={() => handleSelectSubItem(choice.uniqueId, item, currentQuantity - 1, choice.title, false)}>
                                                                    <img src="/img/icon11.svg"/>
                                                                </button>
                                                                <span>{currentQuantity}</span>
                                                            </>
                                                        )}


                                                           {isChoiceItem && <button className="jia" onClick={() => handleSelectSubItem(choice.uniqueId, item, currentQuantity + 1, choice.title, false, choice.NumberOfChoice, choice)}>
                                                                <img src="/img/icon10.svg" />
                                                            </button>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                                
                                
                                
                            ))}
                            {selectedSubmenu[0].SpellInstruction===1 &&(
                            <div key="spellInstruction">
                                <div className='gg_title'>{ui('spellInstruction')}</div>
                                <div className='gg_t1' style={{marginTop:-5}}>
                                        
        {!showNoteBox ? (
            <div className='zdy_card2'  >
          <div className='cell'style={{padding:10}}>
            <div 
              className="cell2" 
              onClick={() => setShowNoteBox(true)}
              style={{ 
                backgroundColor: 'rgb(236, 236, 236)', 
                borderRadius: '4px', 
                padding: '9px', 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center' 
              }}
            >
              {/* <span style={{ fontSize: '14px', fontWeight: 'bold' }}>Notes</span> */}
              <img src="/img/plus-black-bold.svg" alt="Add" style={{ width: '14px', height: '14px', opacity: '0.6' }} />
            </div>
          </div>
         </div>
        ) : (
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Add a note"
            style={{ 
              width: '100%', 
              padding: '13px', 
            marginTop: '10px', 
            // margin: '10px',
              borderRadius: '4px', 
              border: '1px solid #ddd', 
              fontSize: '14px', 
              resize: 'none', 
              boxSizing: 'border-box', 
              height: '80px',
               
            }}
            maxLength="100"
          />
        )}
        </div>

                            </div>)}
                            <div style={{height:'40px'}}></div>
                        </div>
                        
                        <div className="popup_footer">
                            <div className="gg mb-2">
                            <div>
                                <b>{ui('options')}: </b>
                                {selectedSubmenuItems.map((item, index) => {
                                    if (!toggleOptionsPopup) {
                                        // 当!toggleOptionsPopup为真时，只显示第一个item, 如果index 1存在显示...
                                        return index === 0 ? (
                                            <span key={index}>
                                                {item.itemDescription} x<b>{item.quantity} </b>
                                                {selectedSubmenuItems.length > 1 ? '...' : ''}
                                            </span>
                                        ) : null;
                                    } else {
                                        // 当!toggleOptionsPopup为假时，显示所有item
                                        return (
                                            <span key={index} className="text1">
                                                {item.itemDescription} x<b>{item.quantity}</b>{index < selectedSubmenuItems.length - 1 ? ', ' : ''}
                                            </span>
                                        );
                                    }
                                })}
                            </div>
                           
                              

                            

                                
                                { Object.keys(getChoiceSelectedSubItemNoList()).length !== 0 &&
                                    (!toggleOptionsPopup
                                        ? <img className="img1" src="/img/arrow-up.png" onClick={() => toggleOptions()} />
                                        : <img className="img1" src="/img/arrow-down.png" onClick={() => toggleOptions()} />)
                                }

                                {/* {toggleOptionsPopup&&
                                <img className="img1" src="/img/arrow-up.png" onClick={toggleOptions()}/>} */}
                                <div className="right">
                                    
                                    
                                    <div className="Stepper">
                                        <button >
                                            <img className = "mainItemMinus" style={{ opacity: selectedmainItemQty >= 2 ? 1 : 0.2 }} // 当数量是2或更多时，透明度为1，否则为0.5 
                                            src="/img/minus-black-bold.svg" alt="Minus" onClick={() => selectedmainItemQty > 1 && setMainItemQty(selectedmainItemQty - 1)}/>
                                        </button>
                                        <span>{selectedmainItemQty}</span>
                                        <button className="jia">
                                            <img src="/img/plus-black-bold.svg" onClick={() => setMainItemQty(selectedmainItemQty + 1)}/>
                                        </button>
                                    </div>
                                    
                                </div>
                            </div>
                            <button type="button" className="btn btn-warning btn-block" onClick={() => handleAddToCart()}>{ui('addToCart')}</button>
                        </div>
                    </div>
                </div>
                }

                {cart && cart.length > 0 &&
                <div className={`popup gwc_popup ${toggleCartpopup ? 'show' : ''}`}>
                    <div className="bg"></div>
                    <div className="popup_box">
                        <div className="popup_head">
                            <span>{ui('seleteddishes')}</span>
                            <span className="qk" onClick={()=>clearCart()}>{ui('clearcart')}</span>
                            <img src="/img/icon3.svg" onClick={()=>toggleCartPopup()}/>
                        </div>
                        <div className="popup_body">
                            <div className="sp_list2 v2">
                                <ul>
                                    {  
                                        cart.map((order, index) => {
                                            
                                            const mainItem = getCartOrderMainItem(order);
                                            //console.log(mainItem.spellInstruction);
                                            const subItems = order.slice(2);
                                            const itemLimitState = getPerPersonLimitState(mainItem, 1);
                                            const itemLimitReached = Boolean(itemLimitState.overLimit);

                                        
                                            const orderAmount = getOrderAmount(order);

                                            return (
                                                <li key={index}>
                                                    <a onClick={(e) => handleItemClick(e, order)}>
                                                        <div className="img">
                                                            {/* 图片链接 */}
                                                            <img crossOrigin = "anonymous" 
                                                                src={menuItemImageUrl(mainItem.mainItemCode)} 
                                                                onError={(e) => { e.target.onerror = null; e.target.src = '/img/blank.jpeg';}}/>
                                                        </div>
                                                        <div className="info">
                                                            <div className="r1">{mainItem.mainItemDescription}</div>
                                                            <div className="r4">
                                                                <div className="left">
                                                                    {showPriceInCustomerMenu ? (
                                                                        <>
                                                                            <small>$</small>
                                                                            <span>{orderAmount}</span>
                                                                        </>
                                                                    ) : (
                                                                        <span>&nbsp;</span>
                                                                    )}
                                                                </div>
                                                                <div className="right">
                                                                    <div className="Stepper">
                                                                        <button onClick={() => removeOrderFromCart(order)}>
                                                                            <img src="/img/icon11.svg" />
                                                                        </button>
                                                                        <span>{mainItem.quantity}</span>
                                                                        <button className={`jia ${itemLimitReached ? 'per-person-limit-button' : ''}`} onClick={() => popUpIncreaseItemCount(order)}>
                                                                            <img src="/img/icon10.svg"/>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                    {subItems&&subItems.length>0&&<div className="gg">
                                                    <span><b>Options: </b>
                                                    <span className={!optionsPopupState[index] ? "text1" : ""}>
                                                        {subItems.map((subItem, subIndex) => (
                                                            <span key={subIndex} >
                                                                {subItem.itemDescription} x<b>{subItem.quantity}</b>{subIndex < subItems.length - 1 ? ', ' : ''}
                                                                </span>
                                                        ))}
                                                    </span>
                                                    </span>
                                                    { subItems.length !== 0 &&
                                                        (!optionsPopupState[index]
                                                            ? <img className="img1" src="/img/arrow-up.png" onClick={(e) => { e.stopPropagation(); toggleOptionsPopupState(index); }}/>
                                                            : <img className="img1" src="/img/arrow-down.png" onClick={(e) => { e.stopPropagation(); toggleOptionsPopupState(index); }}/>)
                                                    }
                                                    </div>}
                                                    {mainItem.spellInstruction !==''&& typeof mainItem.spellInstruction !== 'undefined' &&<div className="gg">
                                                        <span><b>Notes: </b>
                                                        <span>
                                                            {mainItem.spellInstruction}
                                                        </span>
                                                        </span>
                                                        </div>}
                                                </li>
                                            );
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>}


                <div className={`gwc ${!imagesLoaded ? 'hide' : ''}`}>
                    <div className="box">
                        <div className="left">
                            <div className="img" id="btn4">
                                {/* <img src="/img/food-grey.svg"/>
                                {<span>{cart.length}</span>} */}
                                <img ref={cartIconRef} id='cart-icon'
                                    src={totalQuantity > 0 ? "/img/food.svg" : "/img/food-grey.svg"} 
                                    onClick={totalQuantity > 0 ? () => toggleCartPopup() : undefined} 
                                />

                                {totalQuantity > 0 && <span id="cartCount">{totalQuantity}</span>}
                            </div>
                            <div className="hj">
                                <p className="text1">
                                    {cart.length === 0 
                                        ? <span style={{fontSize: '15px', color:'#a4a9b0'}}>{ui('nodishesselected')}</span>
                                        : showPriceInCustomerMenu 
                                            ? <> <small>$</small><span>{totalAmount}</span></>
                                            : <span>&nbsp;</span>}
                                </p>
                                {/* <p className="text2">xxxxxx 3.00</p> */}
                            </div>
                        </div>
                        <div className="right">
                            <button type="button" className="btn btn-warning" onClick={() =>  totalQuantity > 0 && checkOut()}>{ui('checkout')}</button>
                        </div>
                    </div>
                </div>

                {/* Promotion Popup */}
                {showPromotionPopup && promotionEnabled && (
                    <div className="promotion-popup-overlay" onClick={() => {
                        setShowPromotionPopup(false);
                        setCountdown(10);
                    }}>
                        <div className="promotion-popup" onClick={(e) => e.stopPropagation()}>
                            <div className="promotion-close" onClick={() => {
                                setShowPromotionPopup(false);
                                setCountdown(10);
                            }}>
                                <img src="/img/icon3.svg" alt="Close" />
                            </div>
                            
                            <div className="promotion-icon">
                                🎉
                            </div>
                            
                            <div className="promotion-content">
                                <h2 className="promotion-title">{promotionTitle}</h2>
                                
                                <div className="promotion-description">
                                    {promotionDescription.split('\n').map((line, index) => (
                                        <p key={index}>{line}</p>
                                    ))}
                                </div>
                                
                                {/* <div className="promotion-details">
                                    {promotionType === 'percentage' && (
                                        <div className="promotion-badge">
                                            <span className="badge-value">{promotionValue}%</span>
                                            <span className="badge-label">OFF</span>
                                        </div>
                                    )}
                                    {promotionType === 'amount' && (
                                        <div className="promotion-badge">
                                            <span className="badge-value">${promotionValue}</span>
                                            <span className="badge-label">OFF</span>
                                        </div>
                                    )}
                                    
                                    {promotionMinAmount > 0 && (
                                        <div className="promotion-minimum">
                                            <small>Minimum purchase: ${promotionMinAmount}</small>
                                        </div>
                                    )}
                                </div> */}
                            </div>
                            
                            <button 
                                className="promotion-cta" 
                                onClick={() => {
                                    setShowPromotionPopup(false);
                                    setCountdown(10);
                                }}
                            >
                                Start Ordering ({countdown})
                            </button>
                        </div>
                    </div>
                )}

                <div className={`side_popup menu_list_side_popup ${side_popup ? 'show' : ''}`}>
                <div className="bg"></div>
                <div className="popup_box">
                    <img src="/img/icon3.svg" className="close" id="btn4" onClick={toggleSidePopup}/>
                    <div className="side_popup_t1">
                        {storeId && <img crossOrigin="anonymous" src={`${process.env.REACT_APP_SERVER_URL}/storeIcon/${storeId}`} onError={(e) => { e.target.onerror = null; e.target.src = '/img/default_top_icon.png';}} />}
                    </div>
                    <div className="side_popup_t2">{storeName}</div>
                    <div className="side_popup_t3">
                        <p className="text1">{ui('openingHours')}</p>
                        {/* <p className="text2">{storeTimetable}</p> */}
                        <div>
                        {getStoreTimetable() && Object.entries(getStoreTimetable()).map(([day, hours]) => 
                            <p key={day} className="text2">
                                {day}: <span className='text3'>{
                                    (hours.start && hours.end) 
                                    ? `${hours.start} - ${hours.end}` 
                                    : "Closed"
                                }
                                {hours.breakStart && hours.breakEnd && ` (Break: ${hours.breakStart} - ${hours.breakEnd})`}
                                </span>
                            </p>
                        )}

                        </div>
                    </div>
                    <div className="side_popup_t3">
                        {/* <p className="text1">Contact Number:</p> */}
                        <p className="text2"> <img src="/img/icon4.svg"/> {storePhone}</p>
                        <p className="text2"> <img src="/img/icon5.svg"/> {storeAddress}</p>
                    </div>
                    <div className="footer">
                        <div className="r1">
                            Powered by <img src="/img/ipos_logo.png"/>
                        </div>
                        {/* <div className="r2">
                            Beautiful menus for QR code table ordering, pickup delivery and payments.
                        </div> */}
                        <div className="r3">
                            <a href="https://www.i-pos.com.au/">{ui('learnMore')}</a>
                        </div>
                    </div>
                </div>
                </div>
                </div>
            }
        </div>
    </div>
    );
}

export default MenuList;
